webpackJsonp([3],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FANTASY_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FANTASY_ACTION_TYPES = exports.FANTASY_ACTION_TYPES = (0, _object.namespacedConsts)({
  TOURNAMENT: {
    LOAD_MORE: true,
    GET_TOURNAMENTS_FEED: true,
    SELECT_TOURNAMENT: true
  }
});

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleActions = exports.API_ENDPOINT_NAME = exports.SCHEDULE_ACTION_TYPES = undefined;
exports.changeNumVisbileItems = changeNumVisbileItems;
exports.fetchData = fetchData;
exports.changeLeague = changeLeague;
exports.changeScheduleDate = changeScheduleDate;

var _fn = __webpack_require__(15);

var _object = __webpack_require__(12);

var _api = __webpack_require__(123);

var _pageDataObject = __webpack_require__(5);

var _fetchSaga = __webpack_require__(56);

var SCHEDULE_ACTION_TYPES = exports.SCHEDULE_ACTION_TYPES = (0, _object.namespacedConsts)({
  CHANGE_LEAGUE: true,
  CHANGE_SCHEDULE_DATE: true,
  CHANGE_NUM_VISIBLE_ITEMS: true
}); /* eslint semi:0 */
/* eslint-disable camelcase */
var API_ENDPOINT_NAME = exports.API_ENDPOINT_NAME = 'MATCHES';

function changeNumVisbileItems(numItems) {
  return function (dispatch, getState) {
    return dispatch({
      type: SCHEDULE_ACTION_TYPES.CHANGE_NUM_VISIBLE_ITEMS,
      state: {
        numItems: numItems
      }
    });
  };
}

function fetchData(dataTransformer) {
  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('matchesEndpoint', _api.getApiEndpoints, API_ENDPOINT_NAME),
      _memoizeFirstCall$mat = _memoizeFirstCall.matchesEndpoint,
      url = _memoizeFirstCall$mat.url,
      endpointName = _memoizeFirstCall$mat.endpointName;

  return function (dispatch, getState) {
    return dispatch({
      type: _fetchSaga.FETCH_REQUEST_ACTION_TYPE,
      payload: {
        url: url,
        endpointName: endpointName,
        dataTransformer: dataTransformer,
        additionalState: {
          IS_INITIALIZED: true
        }
      }
    });
  };
}

function changeLeague(leagueName) {
  var leagueId = (0, _pageDataObject.getLeaguesForFixtures)().find(function (league) {
    return league.name === leagueName;
  }).id;
  return function (dispatch, getState) {
    return dispatch({
      type: SCHEDULE_ACTION_TYPES.CHANGE_LEAGUE,
      state: {
        leagueId: leagueId,
        leagueName: leagueName,
        leagueChanged: true
      }
    });
  };
}

function changeScheduleDate(newDate) {
  return function (dispatch, getState) {
    return dispatch({
      type: SCHEDULE_ACTION_TYPES.CHANGE_SCHEDULE_DATE,
      state: {
        scheduleDate: newDate
      }
    });
  };
}

var scheduleActions = exports.scheduleActions = {
  fetchData: fetchData, changeLeague: changeLeague, changeScheduleDate: changeScheduleDate, changeNumVisbileItems: changeNumVisbileItems
};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FACEBOOK_BOT_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FACEBOOK_BOT_ACTION_TYPES = exports.FACEBOOK_BOT_ACTION_TYPES = (0, _object.namespacedConsts)({
  GO_TO_MESSENGER_BOT: true
});

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMatchResponse = transformMatchResponse;
var TEAM_SIDES = {
  HOME: 'home',
  AWAY: 'away'
};
var MATCH_STATUSES = exports.MATCH_STATUSES = {
  FINISHED: 'finished',
  UPCOMING: 'upcoming'
};
var API_STATUSES = {
  FINISHED: 'finished'
};
function getTeamData(matchInput, teamSide) {
  var teamName = matchInput[teamSide + '_nick'];
  var teamLogo = matchInput[teamSide + '_logo'];
  return {
    name: teamName,
    image: teamLogo
  };
}
function getMatchDate(matchData) {
  var epochTime = matchData.start_time;

  return new Date(1000 * epochTime);
}
function getMatchStatus(matchData) {
  return matchData.status === API_STATUSES.FINISHED ? MATCH_STATUSES.FINISHED : MATCH_STATUSES.UPCOMING;
}
function getMatchResult(matchData) {
  var score = matchData.match_score;
  var home = score.home_team,
      away = score.away_team;

  return {
    home: home,
    away: away
  };
}
function transformMatchResponse(serverMatch) {
  var clientMatch = {
    homeTeam: getTeamData(serverMatch, TEAM_SIDES.HOME),
    awayTeam: getTeamData(serverMatch, TEAM_SIDES.AWAY),
    result: getMatchResult(serverMatch),
    date: getMatchDate(serverMatch),
    status: getMatchStatus(serverMatch)
  };
  return clientMatch;
}

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectPostCampaigns = exports.injectHeaderCampaigns = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _campaignInjectors;

var _campaignManagerProvider = __webpack_require__(155);

var _appStore = __webpack_require__(23);

var _logo = __webpack_require__(222);

var _geolocationProvider = __webpack_require__(44);

var _initCampaigns = __webpack_require__(144);

var _CampaignInjector = __webpack_require__(143);

var _CampaignInjector2 = _interopRequireDefault(_CampaignInjector);

var _ua = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER = 'commercialWidgetTaboolaFeedPlaceHolder';
var VIEWABILITY_LABEL = 'data-viewability_label';
var MINIMUM_NUMBER_OF_PARAGRAPHS = 3;
var isEmbedded = _ua.path.isEmbedded;


var canInjectHeader = function canInjectHeader() {
  return true;
};

var canInjectBelowArticle = function canInjectBelowArticle() {
  return (0, _initCampaigns.postCategoriesAllowCampaigns)();
};

var canInjectInArticle = function canInjectInArticle() {
  var index = (0, _initCampaigns.findPositionToInjectCampaign)();
  return (0, _initCampaigns.postCategoriesAllowCampaigns)() && (0, _initCampaigns.postHasAtLeastParagraphs)(MINIMUM_NUMBER_OF_PARAGRAPHS) && index !== -1 && !window.location.search.includes('app=1') && !isEmbedded;
};

var headerCampaignInjector = function headerCampaignInjector(payload) {
  (0, _appStore.dispatch)((0, _logo.changeLogo)(payload.src));
};

var inArticleCampaignInjector = function inArticleCampaignInjector(payload) {
  var campaignElement = (0, _initCampaigns.generateCampaignElement)(payload.embedCode);
  var index = -1;
  if ((0, _geolocationProvider.getCountryCode)() === 'ES') {
    index = (0, _initCampaigns.findPositionToInjectCampaignEs)();
  } else {
    index = (0, _initCampaigns.findPositionToInjectCampaign)();
  }
  var paragraph = (0, _initCampaigns.getPostItems)()[index];
  paragraph && paragraph.insertAdjacentElement('afterend', campaignElement);

  (0, _initCampaigns.registerElementToViewabilityTracker)(campaignElement.firstChild);
  (0, _initCampaigns.dispatchWidgetEmbed)(campaignElement.firstChild, VIEWABILITY_LABEL);
};

var belowArticleCampaignInjector = function belowArticleCampaignInjector(payload) {
  var campaignElement = (0, _initCampaigns.generateCampaignElement)(payload.embedCode);

  var taboolaPlaceholder = document.getElementsByClassName(COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER)[0];
  taboolaPlaceholder && taboolaPlaceholder.insertAdjacentElement('beforeend', campaignElement);

  (0, _initCampaigns.registerElementToViewabilityTracker)(campaignElement.firstChild);
  (0, _initCampaigns.dispatchWidgetEmbed)(campaignElement.firstChild, VIEWABILITY_LABEL);
};

var POSITIONS = {
  HEADER: 'header',
  IN_ARTICLE: 'inArticle',
  BELOW_ARTICLE: 'belowArticle'
};

var campaignInjectors = (_campaignInjectors = {}, (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.HEADER, new _CampaignInjector2.default(headerCampaignInjector, canInjectHeader)), (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.IN_ARTICLE, new _CampaignInjector2.default(inArticleCampaignInjector, canInjectInArticle)), (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.BELOW_ARTICLE, new _CampaignInjector2.default(belowArticleCampaignInjector, canInjectBelowArticle)), _campaignInjectors);

var injectHeaderCampaigns = exports.injectHeaderCampaigns = function injectHeaderCampaigns() {
  return (0, _campaignManagerProvider.getCampaignsFromCampaignManager)().then(function (campaigns) {
    campaigns.filter(function (campaign) {
      return campaign.position === POSITIONS.HEADER;
    }).forEach(function (campaign) {
      var _campaignInjectors$ca = campaignInjectors[campaign.position],
          validate = _campaignInjectors$ca.validate,
          inject = _campaignInjectors$ca.inject;

      if (validate()) {
        inject(campaign.payload);
      }
    });
  });
};

var injectPostCampaigns = exports.injectPostCampaigns = function injectPostCampaigns() {
  return (0, _campaignManagerProvider.getCampaignsFromCampaignManager)().then(function (campaigns) {
    campaigns.filter(function (campaign) {
      return campaign.position !== POSITIONS.HEADER;
    }).forEach(function (campaign) {
      var _campaignInjectors$ca2 = campaignInjectors[campaign.position],
          validate = _campaignInjectors$ca2.validate,
          inject = _campaignInjectors$ca2.inject;

      if (validate()) {
        inject(campaign.payload);
      }
    });
  });
};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(156), __esModule: true };

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.FRESH8_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FRESH8_ACTION_TYPES = exports.FRESH8_ACTION_TYPES = (0, _object.namespacedConsts)({
  DISPLAY_POPUP: true,
  HIDE_POPUP: true,
  DISPLAY_FLOATING_BUTTON: true
});
function displayPopup() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_POPUP,
      state: {
        isPopupVisible: true
      }
    });
  };
}
function hidePopup() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.HIDE_POPUP,
      state: {
        isPopupVisible: false
      }
    });
  };
}
function displayFloatingButton() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_FLOATING_BUTTON,
      state: {
        isFloatingButtongVisible: true
      }
    });
  };
}
var actions = exports.actions = { displayPopup: displayPopup, hidePopup: hidePopup, displayFloatingButton: displayFloatingButton, FRESH8_ACTION_TYPES: FRESH8_ACTION_TYPES };

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(559);
module.exports = __webpack_require__(592);


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

exports.default = addAnalyticsClickDelegator;

var _console = __webpack_require__(11);

var _dom = __webpack_require__(13);

var _window = __webpack_require__(8);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

var _analyticsActions2 = _interopRequireDefault(_analyticsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FEATURE_FLAGS = {
  debug: _window.queryString.debugAnalyticsClickHandler
}; /* eslint consistent-return:0 */


var hasAnalyticsClickEventCategoryAttribute = function hasAnalyticsClickEventCategoryAttribute(target) {
  return target && target.hasAttribute('data-analytics-event-category');
};

var isAnchor = function isAnchor(el) {
  return el instanceof HTMLAnchorElement;
};

var isButton = function isButton(el) {
  return el instanceof HTMLButtonElement;
};

var isAnalyticsElement = function isAnalyticsElement(el) {
  return (isAnchor(el) || isButton(el)) && hasAnalyticsClickEventCategoryAttribute(el);
};

var parentUntilCategoryAttribute = (0, _dom.parentElementUntil)(hasAnalyticsClickEventCategoryAttribute);

var parentUntilClickable = (0, _dom.parentElementUntil)(isAnalyticsElement);

function debug() {
  FEATURE_FLAGS.debug && _console.info.apply(undefined, ['[analytics click handler]'].concat(Array.prototype.slice.call(arguments)));
}

function lowerCaseIfString(value) {
  return typeof value === 'string' ? value.toLowerCase() : value;
}

function normalizeEventData(eventMetadata) {
  return (0, _entries2.default)(eventMetadata).reduce(function (acc, _ref, idx) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (idx === 0) {
      return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, value));
    }
    return value === undefined ? acc : (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, lowerCaseIfString(value)));
  }, {});
}

function addGtmAnchorCallback(evt) {
  var maybeClickable = parentUntilClickable(evt.target);
  if (!maybeClickable || !maybeClickable.target || maybeClickable.target.length > 0) {
    return;
  }

  evt.preventDefault();
  return {
    eventCallback: function eventCallback() {
      window.location = maybeClickable.href;
    },

    eventTimeout: 1000
  };
}

function delegatedAnalyticsClickHandler(evt) {
  var gtmAnchorCallback = addGtmAnchorCallback(evt);
  var target = evt.target;
  debug('target', target);
  var targetDataValue = target.dataset.analyticsEventValue;
  var analyticsElementOrNull = parentUntilCategoryAttribute(target);
  if (!analyticsElementOrNull) {
    return;
  }
  var _analyticsElementOrNu = analyticsElementOrNull.dataset,
      eventCategory = _analyticsElementOrNu.analyticsEventCategory,
      eventAction = _analyticsElementOrNu.analyticsEventAction,
      eventLabel = _analyticsElementOrNu.analyticsEventLabel,
      eventValue = _analyticsElementOrNu.analyticsEventValue;

  if (eventCategory && eventAction) {
    (0, _appStore.dispatch)(_analyticsActions2.default.pageClicked(normalizeEventData({
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventValue: eventValue || targetDataValue,
      gtmAnchorCallback: gtmAnchorCallback
    })));
  }
}

function addAnalyticsClickDelegator() {
  document.body.addEventListener('click', delegatedAnalyticsClickHandler);
}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _initCampaigns = __webpack_require__(124);

var _initGlobalRejectionHandler = __webpack_require__(145);

var _initGlobalRejectionHandler2 = _interopRequireDefault(_initGlobalRejectionHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Initializes modules, which are used across all pages in app.
 */
(0, _initGlobalRejectionHandler2.default)();
(0, _initCampaigns.injectHeaderCampaigns)();

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsServices = undefined;

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = init;

var _analyticsStore = __webpack_require__(51);

var _analyticsStore2 = _interopRequireDefault(_analyticsStore);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _pageContext = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsServicesConditions = {
  default_services: function default_services() {
    return true;
  },
  slideshow_native_app_services: function slideshow_native_app_services() {
    return _pageDataObject2.default.isSlideshow && (0, _ua.getIsNativeApp)();
  },
  non_native_app_services: function non_native_app_services() {
    return !(0, _ua.getIsNativeApp)();
  },
  facebook_analytics: function facebook_analytics() {
    return !(0, _ua.getIsNativeApp)() && _pageDataObject2.default.get('config.facebook_pixel') && !(0, _pageContext.getInfluencerId)();
  },
  full_layout_services: function full_layout_services() {
    return _ua.path.isFullLayout;
  }
};

var supportedAnalyticsServices = _pageDataObject2.default.get('config.analytics_services');
var analyticsServices = exports.analyticsServices = [];
var site = NM.pdo.get('context.site');
for (var analyticsServicesGroup in supportedAnalyticsServices) {
  var condition = analyticsServicesConditions[analyticsServicesGroup];
  if (condition()) {
    var services = supportedAnalyticsServices[analyticsServicesGroup] || [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var service = _step.value;

        analyticsServices.push(__webpack_require__(175)("./" + service + 'Service').default);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

var analyticsStore = _analyticsStore2.default.create();

function init() {
  analyticsServices.forEach(function (Class) {
    Class.create({ store: analyticsStore });
  });
}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignInjector = function CampaignInjector(inject, validate) {
  (0, _classCallCheck3.default)(this, CampaignInjector);

  this.inject = inject;
  this.validate = validate;
};

exports.default = CampaignInjector;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchWidgetEmbed = exports.registerElementToViewabilityTracker = exports.generateCampaignElement = exports.findPositionToInjectCampaignEs = exports.findPositionToInjectCampaign = exports.getPostItems = exports.postCategoriesAllowCampaigns = exports.postHasAtLeastParagraphs = exports.generateEmbedContent = exports.generateInsertableHTML = undefined;

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _pageDataObject = __webpack_require__(5);

var _viewbilityTracker = __webpack_require__(99);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyAttributes = function copyAttributes(elemFrom, elemTo) {
  return (0, _from2.default)(elemFrom.attributes).forEach(function (attr) {
    return elemTo.setAttribute(attr.name, attr.value);
  });
};

var convertToExecutableScripts = function convertToExecutableScripts(scripts) {
  return scripts.map(function (script) {
    var executable = document.createElement('script');
    executable.innerHTML = script.innerHTML ? script.innerHTML : '';
    copyAttributes(script, executable);
    return executable;
  });
};

var isJS = function isJS(script) {
  return script.type === '' || script.type.indexOf('javascript') >= 0;
};

var findJavaScriptElements = function findJavaScriptElements(wrapper) {
  var scripts = (0, _from2.default)(wrapper.getElementsByTagName('script'));
  return scripts.filter(isJS);
};

var removeScripts = function removeScripts(scripts) {
  scripts.forEach(function (script) {
    return script.remove();
  });
};

var wrapHTML = function wrapHTML(html) {
  var tempWrapper = window.parent.document.createElement('div');
  tempWrapper.innerHTML = html;
  return tempWrapper;
};

var generateInsertableHTML = exports.generateInsertableHTML = function generateInsertableHTML(html) {
  var wrapper = wrapHTML(html);
  var scripts = findJavaScriptElements(wrapper);
  // Remove injected scripts and leave only created executable scripts
  removeScripts(scripts);
  var elements = (0, _from2.default)(wrapper.childNodes);
  return {
    elements: elements,
    scripts: convertToExecutableScripts(scripts)
  };
};

var generateEmbedContent = exports.generateEmbedContent = function generateEmbedContent(data) {
  var elements = data.elements,
      scripts = data.scripts;

  var el = document.createElement('div');
  el.style.width = '100%';
  elements.forEach(function (elem) {
    el.appendChild(elem);
  });
  scripts.forEach(function (script) {
    el.appendChild(script);
  });
  return el;
};

var postHasAtLeastParagraphs = exports.postHasAtLeastParagraphs = function postHasAtLeastParagraphs(minimumParagraphs) {
  var initialParagraphs = document.querySelectorAll('.post-content > p').length;
  var emptyParagraphs = document.querySelectorAll('.post-content > p > br').length;
  return initialParagraphs - emptyParagraphs > minimumParagraphs;
};

var postCategoriesAllowCampaigns = exports.postCategoriesAllowCampaigns = function postCategoriesAllowCampaigns() {
  var postCategories = (0, _pageDataObject.getPostCategories)();
  return !postCategories.includes('no-campaign-manager') && (!postCategories.includes('sponsored') || postCategories.includes('wirewax'));
};

var isParagraph = function isParagraph(node) {
  var nodeHTML = node.innerHTML;
  var isBoldTitle = nodeHTML.match('<strong>.+<\\/strong>') !== null;
  return node.innerText !== '' && nodeHTML !== '<span style="font-size: 1em;"><br></span>' && nodeHTML !== '<strong><br></strong>' && !isBoldTitle && nodeHTML !== '&nbsp;';
};

var getPostItems = exports.getPostItems = function getPostItems() {
  return [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.post-content > *')));
};

var findPositionToInjectCampaign = exports.findPositionToInjectCampaign = function findPositionToInjectCampaign() {
  var postItems = getPostItems();
  var isParagraphArray = postItems.map(function (x) {
    return isParagraph(x);
  });
  var startPoint = parseInt(isParagraphArray.length / 2, 10);
  for (var i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i] && isParagraphArray[i + 1]) {
      return i;
    }
  }
  return -1;
};

var findPositionToInjectCampaignEs = exports.findPositionToInjectCampaignEs = function findPositionToInjectCampaignEs() {
  var postItems = getPostItems();
  var isParagraphArray = postItems.map(function (x) {
    return isParagraph(x);
  });
  var startPoint = parseInt(isParagraphArray.length, 1);
  for (var i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i]) {
      return i;
    }
  }
  return -1;
};

var generateCampaignElement = exports.generateCampaignElement = function generateCampaignElement(script) {
  var parsedScript = generateInsertableHTML('' + script);
  return generateEmbedContent(parsedScript);
};

var registerElementToViewabilityTracker = exports.registerElementToViewabilityTracker = function registerElementToViewabilityTracker(element) {
  (0, _viewbilityTracker.register)('.' + element.className);
};

var dispatchWidgetEmbed = exports.dispatchWidgetEmbed = function dispatchWidgetEmbed(element, viewabilityLabel) {
  (0, _appStore.dispatch)((0, _analyticsActions.widgetEmbedEvent)(element.getAttribute(viewabilityLabel)));
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initGlobalPromiseRejectionHandler;

var _dom = __webpack_require__(13);

var _console = __webpack_require__(11);

// https://devdocs.io/dom_events/unhandledrejection
function globalPromiseRejectionHandler(event) {
  // eslint-disable-line no-shadow
  var reason = event.reason,
      promise = event.promise;

  (0, _console.warn)('Unhandled Promise rejection caught: \'' + reason + '\'!', { event: event, reason: reason, promise: promise });
}

function initGlobalPromiseRejectionHandler() {
  return (0, _dom.addWindowEvent)('unhandledrejection', globalPromiseRejectionHandler);
}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setLocaleCookie;

var _cookies = __webpack_require__(180);

var _window = __webpack_require__(8);

function setLocaleCookie() {
  if (_window.queryString.setLocale) {
    (0, _cookies.set)('locale', _window.path.substr(1), { path: '/', expires: new Date('2020', '1', '1') });
  }
}

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _pageContext = __webpack_require__(61);

var _pageDataObject = __webpack_require__(5);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _currentPostActionCounterProvider = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_DATA_OBJECT_FALLBACK = {
  post: {
    // Defaults for failed pageDataObject parsing
    id: null,
    author: {
      id: null,
      league: null
    }
  },
  page: {}
}; /* eslint semi:0 */

var ActionCounterService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(ActionCounterService, _AnalyticsBaseService);

  function ActionCounterService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ActionCounterService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionCounterService.__proto__ || (0, _getPrototypeOf2.default)(ActionCounterService)).call(this, options));

    _this.facebookShare = _this.twitterShare = _this.whatsappShare = _this.socialShare;
    var post = (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post);
    var author = post.author,
        actionCounterTag = post.action_counter_tag;

    _this.basicPostAndAuthorData = {
      post: post.id,
      author: author.id,
      league: actionCounterTag
    };
    if (_userStore2.default.state.id) {
      _this.basicPostAndAuthorData.user = _userStore2.default.state.id;
    }
    return _this;
  }

  (0, _createClass3.default)(ActionCounterService, [{
    key: 'routeChanged',
    value: function routeChanged(action) {
      //Empty override to prevent a read report on slideshows on each slide change
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {
      if (this.shouldReportPageview()) {
        this.trackEvent('reads', this.pageViewData);
      }
    }
  }, {
    key: 'shouldReportPageview',
    value: function shouldReportPageview() {
      var postId = (0, _pageDataObject.get)('post.id', false);
      if (postId === false) {
        return false;
      }
      return _userStore2.default.recentReads[postId].readsCount <= 1;
    }
  }, {
    key: 'socialShare',
    value: function socialShare() {
      this.trackEvent('shares', this.basicPostAndAuthorData);
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(type, params) {
      if (!(0, _ua.getIsBot)()) {
        this.logAnalytics(type, params);
        (0, _currentPostActionCounterProvider.sendData)(type, params);
      }
    }
  }, {
    key: 'className',
    get: function get() {
      return 'ActionCounterService';
    }
  }, {
    key: 'pageViewData',
    get: function get() {
      var _Object$assign = (0, _assign2.default)(PAGE_DATA_OBJECT_FALLBACK, {
        post: (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post),
        page: (0, _pageDataObject.get)('page', PAGE_DATA_OBJECT_FALLBACK.page)
      }),
          post = _Object$assign.post,
          page = _Object$assign.page;

      var author = post.author;

      var data = (0, _assign2.default)({}, this.basicPostAndAuthorData, {
        locale: page.locale,
        domain: page.site,
        aid: (0, _pageContext.getInfluencerId)() || _window.queryString.af,
        featured_to_site: post.featured_to_site // eslint-disable-line camelcase
      });
      return data;
    }
  }]);
  return ActionCounterService;
}(_analyticsBaseService2.default);

exports.default = ActionCounterService;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _externalScripts = __webpack_require__(52);

var _fn = __webpack_require__(15);

var _script = __webpack_require__(19);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _i18nProvider = __webpack_require__(18);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable camelcase, key-spacing, no-multi-spaces, lines-around-comment, */
/* eslint semi:0 */
var AGOF_DEFAULT_PARAMS = {
  sv: 'i2',
  st: 'ftbpro'
};
var AGOF_DEFAULT_TAG = { cp: 'dTxUcCpOqKyFz02', co: '/other' };
var AGOF_STATIC_PAGE_TAG = { cp: 'dTxRcCpOqKyFz20serv', co: '/service' };
var AGOF_TAGS_DICTIONARY = {
  league: AGOF_DEFAULT_TAG,
  homepage: { cp: 'dTxRcHpOqKyFz02home', co: '/homepage', sv: 'ke' },
  league_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  league_leaderboard: { cp: 'dTxUcCpOqKyFz27auto', co: '/autoren' },
  team: { cp: 'dTxUcCpOqKyFz02mann', co: '/mannschaften' },
  team_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  users: { cp: 'dTxUcCpOqKyFz27prof', co: '/profile' },
  post: { cp: 'dTxUcCpOqKyFz02arti', co: '/meldungen' },
  about: AGOF_STATIC_PAGE_TAG,
  writersfaq: AGOF_STATIC_PAGE_TAG,
  rules: AGOF_STATIC_PAGE_TAG,
  terms: AGOF_STATIC_PAGE_TAG,
  contact: AGOF_STATIC_PAGE_TAG,
  privacy_policy: AGOF_STATIC_PAGE_TAG,
  mobile_apps: AGOF_STATIC_PAGE_TAG,
  affiliates: AGOF_STATIC_PAGE_TAG
  /* eslint-enable */

  // NOTICE: this class should be (and is) used only when not in native app
};
var AgofService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(AgofService, _AnalyticsBaseService);

  function AgofService() {
    var _ref;

    (0, _classCallCheck3.default)(this, AgofService);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AgofService.__proto__ || (0, _getPrototypeOf2.default)(AgofService)).call.apply(_ref, [this].concat(args)));

    if (_this.shouldReportPageview()) {
      _this.agofLoader = _script.external.load({ name: _externalScripts.externalScriptsConfig.agof.name });
    }
    return _this;
  }

  (0, _createClass3.default)(AgofService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      if (this.shouldReportPageview()) {
        this.trackEvent(this.pageViewData);
      }
    }
  }, {
    key: 'shouldReportPageview',
    value: function shouldReportPageview() {
      var forceAgofReport = _window.queryString.forceAgofReport;

      return forceAgofReport || (0, _fn.allTrue)((0, _pageDataObject.isSupportedForDomain)('Agof'), _i18nProvider.locale === _i18nProvider.AVAILABLE_LOCALES.DE, (0, _pageDataObject.get)('config.env') !== 'development');
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(data) {
      if (this.shouldReportPageview()) {
        this.logAnalytics(data);
        this.agofLoader((0, _fn.makeSafeFn)(function () {
          return window.iom.c(data, 2);
        }));
      }
    }
  }, {
    key: 'className',
    get: function get() {
      return 'AgofService';
    }
  }, {
    key: 'pageViewData',
    get: function get() {
      var currentTag = AGOF_TAGS_DICTIONARY[(0, _pageDataObject.get)('page.type')] || AGOF_DEFAULT_TAG;
      var tagWithDefaults = (0, _extends3.default)({}, AGOF_DEFAULT_PARAMS, currentTag);
      var sha1 = _userStore2.default.state.sha1;

      if (sha1) {
        tagWithDefaults.mc = sha1;
      }
      return tagWithDefaults;
    }
  }]);
  return AgofService;
}(_analyticsBaseService2.default);

exports.default = AgofService;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _dom = __webpack_require__(13);

var _ua = __webpack_require__(10);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _adStore = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOST = 'ec2-54-185-154-151.us-west-2.compute.amazonaws.com'; /* eslint semi:0 */

var AnalyticsCounterService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(AnalyticsCounterService, _AnalyticsBaseService);

  function AnalyticsCounterService() {
    (0, _classCallCheck3.default)(this, AnalyticsCounterService);
    return (0, _possibleConstructorReturn3.default)(this, (AnalyticsCounterService.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsCounterService)).apply(this, arguments));
  }

  (0, _createClass3.default)(AnalyticsCounterService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent('pageview', { platform: (0, _ua.getPlatform)() });
    }
  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {
      //Empty override to prevent a read report on slideshows on each slide change
    }
  }, {
    key: 'adBlockDetectionFinished',
    value: function adBlockDetectionFinished() {
      this.trackEvent('adblock', {
        platform: (0, _ua.getPlatform)(),
        adblock_detected: _adStore.adStore.isAdblockPresent
      });
    }
  }, {
    key: 'slotRendered',
    value: function slotRendered(action) {
      var lineitem = void 0;
      if (action.event.isEmpty) {
        lineitem = 'empty';
      } else {
        lineitem = action.event.lineItemId || 'adx';
      }
      this.trackEvent('ad_served', {
        platform: (0, _ua.getPlatform)(),
        ad_unit: action.adId,
        lineitem: lineitem
      });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(type, params) {
      for (var k in params) {
        params[k] = params[k].toString().replace(' ', '-');
      }
      params.ts = Date.now();
      this.logAnalytics(type, params);
      var serializedParams = _mithril2.default.route.buildQueryString(params);
      (0, _dom.makeImage)({ src: '//' + HOST + '/' + type + '?' + serializedParams });
    }
  }, {
    key: 'className',
    get: function get() {
      return 'AnalyticsCounterService';
    }
  }]);
  return AnalyticsCounterService;
}(_analyticsBaseService2.default);

exports.default = AnalyticsCounterService;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _script = __webpack_require__(19);

var _fn = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var comscore = _script.external.load({
  name: 'comscore',
  loadNow: true
});

//NOTICE: this class should be (and is) used only when not in native app
/* eslint semi:0 */

var ComscoreService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(ComscoreService, _AnalyticsBaseService);

  function ComscoreService() {
    (0, _classCallCheck3.default)(this, ComscoreService);
    return (0, _possibleConstructorReturn3.default)(this, (ComscoreService.__proto__ || (0, _getPrototypeOf2.default)(ComscoreService)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComscoreService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent({});
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(data) {
      this.logAnalytics(data);
      comscore((0, _fn.makeSafeFn)(function () {
        return window.COMSCORE.beacon(data);
      }));
    }
  }, {
    key: 'className',
    get: function get() {
      return 'ComscoreService';
    }
  }]);
  return ComscoreService;
}(_analyticsBaseService2.default);

exports.default = ComscoreService;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _script = __webpack_require__(19);

var _analyticsStore = __webpack_require__(51);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const fbPixel = externalScript.load({ name: 'facebookPixel' })
// fbPixel(makeSafeFn(_ => window.fbq('init', getFromPdo('config.facebook_pixel.id'))))

/* eslint semi:0 */
var DEFINED_EVENTS = ['PageView', 'ViewContent', 'Search', 'AddToCart', 'AddToWishlist', 'InitiateCheckout', 'AddPaymentInfo', 'Purchase', 'Lead', 'CompleteRegistration'];

var FacebookAnalyticsService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(FacebookAnalyticsService, _AnalyticsBaseService);

  function FacebookAnalyticsService() {
    (0, _classCallCheck3.default)(this, FacebookAnalyticsService);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookAnalyticsService.__proto__ || (0, _getPrototypeOf2.default)(FacebookAnalyticsService)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookAnalyticsService, [{
    key: 'pageViewed',
    value: function pageViewed() {}
    // const oldPixels = getFromPdo('config.facebook_pixel.old_pixels') || []
    // for (const oldPixel of oldPixels) {
    //   this.trackEventOld(oldPixel)
    // }
    // this.trackEvent('PageView')
    // this.multiPageViews()
    // this.desktopPageview()


    // multiPageViews() {
    //   const postsInSession = Object.keys(userStore.recentReads).length
    //   if (postsInSession > 1) {
    //     this.trackEvent('multiPostsViews', { numPosts: postsInSession })
    //   }
    // }

    // desktopPageview() {
    //   if (getIsDesktop()) {
    //     this.trackEvent('desktopPageview')
    //   }
    // }

  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {}
    //Empty override to prevent a read report on slideshows on each slide change


    // scrollAnchorReached(action) {
    //   if (action.payload.anchor === SCROLL_EVENTS_SELECTORS.SHARE_BUTTONS_BOTTOM) {
    //     this.reportOnce(action, () => {
    //       this.trackEvent('ScrolledToArticleEnd')
    //     })
    //   }
    // }

    // heartBeat() {
    //   const millisecondsPassed = this.store.heartbeatsCount * HEART_BEAT_PERIOD
    //   if (millisecondsPassed === 30000) {
    //     this.trackEvent('HalfMinuteOnPage')
    //   }
    // }

    // socialShare(action) {
    //   this.trackEvent('SharedArticle')
    // }

  }, {
    key: 'trackEvent',
    value: function trackEvent(type, args) {
      var data = (0, _assign2.default)({}, this.defaultEventArgs, args); //NOTICE: for some reason when using makeEmptyObj in Object.assign instead of {}, then it doesn't work and the fbq SDK raise an error
      var trackType = DEFINED_EVENTS.includes(type) ? 'track' : 'trackCustom';
      this.logAnalytics(type, data);
      // fbPixel(makeSafeFn(_ => window.fbq(trackType, type, data)))
    }

    // trackEventOld(pixelUrl) {
    //   this.logAnalytics(pixelUrl)
    //   makeImage({ src: pixelUrl })
    // }

  }, {
    key: 'className',
    get: function get() {
      return 'FacebookAnalyticsService';
    }
  }, {
    key: 'defaultEventArgs',
    get: function get() {
      return {};
    }
  }]);
  return FacebookAnalyticsService;
}(_analyticsBaseService2.default);

exports.default = FacebookAnalyticsService;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ua = __webpack_require__(10);

var _window2 = __webpack_require__(8);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _pageDataObject = __webpack_require__(5);

var _script = __webpack_require__(19);

var _analyticsStore = __webpack_require__(51);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAnalyticsClickHandler = _window2.queryString.debugAnalyticsClickHandler; /* eslint semi:0 */

var CUSTOM_DIMENSIONS = {
  SESSION: {
    PLATFORM: 'dimension1',
    USER_LOGGED_IN: 'dimension3'
  },
  HIT: {
    POST_TEMPLATE: 'dimension2'
  }
};
var YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS = ['event', 'Y! DF'];
var googleAnalytics = _script.external.load({ name: 'googleAnalytics', loadNow: true });

var GoogleAnalyticsService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(GoogleAnalyticsService, _AnalyticsBaseService);

  function GoogleAnalyticsService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleAnalyticsService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleAnalyticsService.__proto__ || (0, _getPrototypeOf2.default)(GoogleAnalyticsService)).call(this, options));

    _this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.PLATFORM, (0, _ua.getPlatform)());
    _this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, _userStore2.default.isLoggedIn ? 'loggedIn' : 'loggedOut');
    _this.existingUserAuthenticated = _this.newUserAuthenticated = _this.userAuthenticated;
    return _this;
  }

  (0, _createClass3.default)(GoogleAnalyticsService, [{
    key: 'riddleEmbedMessage',
    value: function riddleEmbedMessage(_ref) {
      var _ref$payload = _ref.payload,
          category = _ref$payload.category,
          label = _ref$payload.label;

      return this.trackEvent('event', 'riddle', category, label);
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent('pageview');
    }
  }, {
    key: 'slotRendered',
    value: function slotRendered(action) {
      if (action.adId === 'Interstitial') {
        this.trackEvent('event', 'Ads', 'Interstitial', 'Display', { nonInteraction: true });
      }
    }
  }, {
    key: 'heartBeat',
    value: function heartBeat() {
      var millisecondsPassed = this.store.heartbeatsCount * _analyticsStore.HEART_BEAT_PERIOD;
      this.trackEvent('event', 'Post', 'Read', millisecondsPassed / 1000 + ' seconds');
    }
  }, {
    key: 'socialShare',
    value: function socialShare(action) {
      var position = action.e.target.parentNode.className;
      var shareTarget = action.type.split(':').pop();
      this.trackEvent('social', shareTarget, position, _window2.path);
    }
  }, {
    key: 'analyticsActionsClickEvent',
    value: function analyticsActionsClickEvent(action) {
      var dataToSend = (0, _entries2.default)(action.state.payload).reduce(function (acc, _ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return [].concat((0, _toConsumableArray3.default)(acc), [value]);
      }, []);

      if (debugAnalyticsClickHandler) {
        (0, _console.info)('CLICK SERVICE RECIEVED ACTION WITH PAYLOAD: ', action.state.payload);
        (0, _console.info)('SENDING TO GA: ', ['event'].concat((0, _toConsumableArray3.default)(dataToSend)));
      }

      this.trackEvent.apply(this, ['event'].concat((0, _toConsumableArray3.default)(dataToSend)));
    }
  }, {
    key: 'jwplayerAnalytics',
    value: function jwplayerAnalytics(_ref4) {
      var _ref4$payload = _ref4.payload,
          eventName = _ref4$payload.eventName,
          videoId = _ref4$payload.videoId;

      this.trackEvent('event', 'Article page', eventName, videoId);
    }

    //videoPlay(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoPause(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoComplete(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoPause(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoError(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoBufferChange({ payload: { eventName, videoId, buffer } }){
    //  this.trackEvent('event', 'Article Page', eventName, `videoId: ${videoId}, buffered: ${buffer.bufferPercent}`);
    //}

  }, {
    key: 'scrollAnchorReached',
    value: function scrollAnchorReached(action) {
      var _this2 = this;

      this.reportOnce(action, function () {
        _this2.setCustomDimension(CUSTOM_DIMENSIONS.HIT.POST_TEMPLATE, (0, _pageDataObject.get)('post.template'));
        _this2.trackEvent('event', 'Scroll', 'Reached', action.payload.anchor);
      });
    }
  }, {
    key: 'userAuthenticated',
    value: function userAuthenticated(action) {
      if (!action.isReauthenticated) {
        this.trackEvent('event', 'User', 'Logged In', null, null, { sessionControl: 'end' });
        this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedIn');
      }
    }
  }, {
    key: 'fbLogin',
    value: function fbLogin(action) {}
  }, {
    key: 'logout',
    value: function logout(action) {
      // on user logged out
      this.trackEvent('event', 'User', 'Logged out', null, null, { sessionControl: 'end' });
      this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedOut');
    }
  }, {
    key: 'vote',
    value: function vote(action) {}
  }, {
    key: 'placeBet',
    value: function placeBet(action) {}
  }, {
    key: 'tournamentGetTournamentsFeed',
    value: function tournamentGetTournamentsFeed(_ref5) {
      var numberOfTournaments = _ref5.state.tournaments.length;

      if (numberOfTournaments) {
        this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['view', 'contest widget']));
      }
    }
  }, {
    key: 'tournamentSelectTournament',
    value: function tournamentSelectTournament(action) {
      this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['enter clicked', 'contest widget']));
    }
  }, {
    key: 'tournamentLoadMore',
    value: function tournamentLoadMore(action) {
      this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['show more', 'contest widget']));
    }
  }, {
    key: 'goToMessengerBot',
    value: function goToMessengerBot(_ref6) {
      var displayMessage = _ref6.state.displayMessage;

      this.trackEvent('event', 'FB bot', 'button click', displayMessage);
    }
  }, {
    key: 'reactionsDisplay',
    value: function reactionsDisplay(action) {
      var reactionsCampaign = (0, _pageDataObject.get)('post.reactions.campaign.name', '');
      var buttonLocation = (0, _keys2.default)(action.state.reactionsComponentState)[0];
      this.trackEvent('event', 'Reactions Web ' + reactionsCampaign, 'Reaction Button Click', buttonLocation);
    }
  }, {
    key: 'reactionsSendVote',
    value: function reactionsSendVote(action) {
      var actionState = action.state;

      var reactionsCampaign = (0, _pageDataObject.get)('post.reactions.campaign.name', '');
      var buttonLocation = actionState.componentPosition,
          reactionId = actionState.selectedReaction;

      this.trackEvent('event', 'Reactions Web ' + reactionsCampaign, 'Reaction Selection ' + buttonLocation, reactionId);
    }
  }, {
    key: 'jwplayerEvent',
    value: function jwplayerEvent(action) {}
  }, {
    key: 'setCustomDimension',
    value: function setCustomDimension(dimension, value) {
      googleAnalytics(function () {
        return window.ga('set', dimension, value);
      });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args.unshift('send');
      this.logAnalytics.apply(this, args);
      googleAnalytics(function () {
        var _window;

        return (_window = window).ga.apply(_window, args);
      });
    }
  }, {
    key: 'className',
    get: function get() {
      return 'GoogleAnalyticsService';
    }
  }]);
  return GoogleAnalyticsService;
}(_analyticsBaseService2.default);

exports.default = GoogleAnalyticsService;

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _fn = __webpack_require__(15);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _adActions = __webpack_require__(50);

var _mithril = __webpack_require__(54);

var _dom = __webpack_require__(13);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var AdblockDetectorProvider = function (_BaseClass) {
  (0, _inherits3.default)(AdblockDetectorProvider, _BaseClass);

  function AdblockDetectorProvider() {
    (0, _classCallCheck3.default)(this, AdblockDetectorProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdblockDetectorProvider.__proto__ || (0, _getPrototypeOf2.default)(AdblockDetectorProvider)).call(this));

    !(0, _pageDataObject.getIsDraft)() && _this.loadAdblockTestScript();
    return _this;
  }

  (0, _createClass3.default)(AdblockDetectorProvider, [{
    key: 'loadAdblockTestScript',
    value: function loadAdblockTestScript() {
      (0, _mithril.safeRequest)({
        method: 'GET',
        url: 'https://static.minutemediacdn.com/assets/qa4/ads-adblock-test.js',
        deserialize: _fn.identity //This is simply to avoid the warning that the response is not a JSON
      }).then(this.onAdblockTestScriptLoaded.bind(this), this.onAdblockTestScriptError.bind(this));
    }
  }, {
    key: 'onAdblockTestScriptLoaded',
    value: function onAdblockTestScriptLoaded() {
      var ad = this.createDummyAd();
      this.adblockDetected = this.isAdHidden(ad);
      this.onAdblockDetectingFinished();
    }
  }, {
    key: 'createDummyAd',
    value: function createDummyAd() {
      var ad = (0, _dom.createElement)('div');
      ad.id = 'adblock-test';
      ad.setAttribute('class', 'ad-dummy pub_300x250');
      ad.setAttribute('style', 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important');
      document.body.appendChild(ad);
      return ad;
    }
  }, {
    key: 'isAdHidden',
    value: function isAdHidden(ad) {
      var isHidden = ad.offsetHeight === 0 || ad.offsetWidth === 0;
      if (!isHidden && window.getComputedStyle) {
        var adStyle = window.getComputedStyle(ad, null);
        isHidden = adStyle.getPropertyValue('display') === 'none' || adStyle.getPropertyValue('visibility') === 'hidden';
      }
      return isHidden;
    }
  }, {
    key: 'onAdblockTestScriptError',
    value: function onAdblockTestScriptError(error) {
      // eslint-disable-line handle-callback-err
      this.adblockDetected = true;
      this.onAdblockDetectingFinished();
    }
  }, {
    key: 'onAdblockDetectingFinished',
    value: function onAdblockDetectingFinished() {
      (0, _adActions.adBlockDetectionFinished)({ detected: this.adblockDetected });
    }
  }]);
  return AdblockDetectorProvider;
}(_BaseClass3.default);

var initAdblockDetectorProvider = AdblockDetectorProvider.create.bind(AdblockDetectorProvider);
exports.default = initAdblockDetectorProvider;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCampaignsFromCampaignManager = undefined;

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _fetch = __webpack_require__(57);

var _window = __webpack_require__(8);

var _pageDataObject = __webpack_require__(5);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDate = function getDate() {
  var date = _window.queryString.localTime ? new Date(_window.queryString.localTime) : new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000);
  date.setSeconds(0, 0);
  return date.toJSON();
};

var getLocale = function getLocale() {
  return _window.queryString.language || (0, _pageDataObject.getPageLocale)();
};

var getTags = function getTags() {
  return _window.queryString.tags || (0, _pageDataObject.getPostCategories)().join(',');
};

var getCampaignsFromCampaignManagerService = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(site, country, localTime, locale, tags) {
    var result;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetch.getJsonOrError)((0, _pageDataObject.getApiServicesEndpoints)().campaigns + '?site=' + site + '&country=' + country + '&localTime=' + localTime + '&language=' + locale + '&tags=' + tags);

          case 2:
            result = _context.sent;
            return _context.abrupt('return', result.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCampaignsFromCampaignManagerService(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var campaignsPromise = null;

var getCampaignsFromCampaignManager = exports.getCampaignsFromCampaignManager = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var countryCode;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _geolocationProvider.getCountryCode)();

          case 2:
            countryCode = _context2.sent;

            if (!campaignsPromise) {
              campaignsPromise = getCampaignsFromCampaignManagerService((0, _pageDataObject.getSite)(), countryCode, getDate(), getLocale(), getTags());
            }

            _context2.next = 6;
            return campaignsPromise;

          case 6:
            return _context2.abrupt('return', _context2.sent);

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getCampaignsFromCampaignManager() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
module.exports = __webpack_require__(20).Object.values;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(40)
  , $values = __webpack_require__(232)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./actionCounterService": 147,
	"./agofService": 148,
	"./analyticsBaseService": 28,
	"./analyticsCounterService": 149,
	"./comscoreService": 150,
	"./facebookAnalyticsService": 151,
	"./googleAnalyticsService": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoUpcomingMatches;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'no-upcoming-matches'; /* eslint semi:0 */
function NoUpcomingMatches(_ref) {
  var message = _ref.message;

  return _react2.default.createElement('div', { className: blockName, 'data-message': message });
}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.scheduleReducer = scheduleReducer;

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _pageDataObject = __webpack_require__(5);

var _fetchSaga = __webpack_require__(56);

var _scheduleActions = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getInitialLeague() {
  var initialLeagueId = _window.queryString.initialLeagueId;

  if (!initialLeagueId) {
    if ((0, _pageDataObject.getLeaguesForFixtures)().length === 0) {
      return {};
    }
    var _getLeaguesForFixture = (0, _pageDataObject.getLeaguesForFixtures)()[0],
        _leagueId = _getLeaguesForFixture.id,
        _leagueName = _getLeaguesForFixture.name;

    return { leagueId: _leagueId, leagueName: _leagueName };
  }
  var leagueId = +initialLeagueId;
  var leagueData = (0, _pageDataObject.getLeaguesForFixtures)().find(function (league) {
    return league.id === leagueId;
  });
  var leagueName = leagueData.name;

  return { leagueId: leagueId, leagueName: leagueName };
} /* eslint semi:0 */


function getDefaultState() {
  var _getInitialLeague = getInitialLeague(),
      leagueId = _getInitialLeague.leagueId,
      leagueName = _getInitialLeague.leagueName;

  return {
    IS_INITIALIZED: false,
    leagueId: leagueId,
    leagueName: leagueName,
    leaguesForFixtures: (0, _pageDataObject.getLeaguesForFixtures)(),
    numItems: 3,
    scheduleDate: new Date()
  };
}

function setState(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

function scheduleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments[1];

  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('SCHEDULE_FETCH_ACTION_TYPES', _fetchSaga.getNamespacedFetchActionTypes, _scheduleActions.API_ENDPOINT_NAME),
      SCHEDULE_FETCH_ACTION_TYPES = _memoizeFirstCall.SCHEDULE_FETCH_ACTION_TYPES;

  if (SCHEDULE_FETCH_ACTION_TYPES) {
    switch (action.type) {
      case SCHEDULE_FETCH_ACTION_TYPES.FETCH.SUCCESS:
      case SCHEDULE_FETCH_ACTION_TYPES.FETCH.FAILED:
      case _scheduleActions.SCHEDULE_ACTION_TYPES.CHANGE_NUM_VISIBLE_ITEMS:
      case _scheduleActions.SCHEDULE_ACTION_TYPES.CHANGE_LEAGUE:
      case _scheduleActions.SCHEDULE_ACTION_TYPES.CHANGE_SCHEDULE_DATE:
        return setState(state, action.state);
      default:
        return state;
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true });
}

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAY_IN_MILLISECONDS = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.toIsoStringDate = toIsoStringDate;
exports.isSameCalendarDay = isSameCalendarDay;
exports.getDateByTime = getDateByTime;
exports.getDateByIso8601string = getDateByIso8601string;
exports.toHourMinute = toHourMinute;
exports.toHourMinuteFromParts = toHourMinuteFromParts;
exports.getCurrentIsoStringDate = getCurrentIsoStringDate;
exports.addDaysToDate = addDaysToDate;

var _nm = __webpack_require__(26);

var _object = __webpack_require__(12);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatNumberToDoubleDigitString(number) {
  return ('0' + number).slice(-2);
} /* eslint semi:0 */
function toIsoStringDate(dateInstance) {
  var _dateInstance$toISOSt = dateInstance.toISOString().split('T'),
      _dateInstance$toISOSt2 = (0, _slicedToArray3.default)(_dateInstance$toISOSt, 2),
      dateString /*timeString*/ = _dateInstance$toISOSt2[0];

  return dateString;
}

var DAY_IN_MILLISECONDS = exports.DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

function isSameCalendarDay(date1, date2) {
  return date1.toDateString() === date2.toDateString();
}

function getDateByTime(time) {
  return new Date(time.getFullYear(), time.getMonth(), time.getDate());
}

function getDateByIso8601string(iso8601string) {
  var _iso8601string$split$ = iso8601string.split('-').map(function (num) {
    return parseInt(num);
  }),
      _iso8601string$split$2 = (0, _slicedToArray3.default)(_iso8601string$split$, 3),
      year = _iso8601string$split$2[0],
      month = _iso8601string$split$2[1],
      day = _iso8601string$split$2[2];

  return new Date(year, month - 1, day);
}

function toHourMinute() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // https://github.com/fnando/i18n-js#date-formatting
  return _i18nProvider.l.apply(undefined, ['time.formats.hour_minute'].concat(args));
}

function toHourMinuteFromParts(_ref) {
  var dateString = _ref.dateString,
      timeString = _ref.timeString;

  // https://github.com/fnando/i18n-js#date-formatting
  return toHourMinute(dateString + 'T' + timeString);
}

function getCurrentIsoStringDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var month = formatNumberToDoubleDigitString(date.getMonth() + 1);
  var day = formatNumberToDoubleDigitString(date.getDate());
  return date.getFullYear() + '-' + month + '-' + day;
}

function addDaysToDate(date, days) {
  var d = new Date();
  return d.setDate(date.getDate() + days);
}

var date = (0, _assign2.default)((0, _object.create)(), {
  DAY_IN_MILLISECONDS: DAY_IN_MILLISECONDS,
  isSameCalendarDay: isSameCalendarDay,
  getDateByTime: getDateByTime,
  getDateByIso8601string: getDateByIso8601string,
  toHourMinute: toHourMinute,
  toHourMinuteFromParts: toHourMinuteFromParts,
  toIsoStringDate: toIsoStringDate,
  getCurrentIsoStringDate: getCurrentIsoStringDate,
  addDaysToDate: addDaysToDate
});

(0, _nm.registerUtils)({ date: date });

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

function getDeviceTypeClass() {
  if ((0, _ua.getIsDesktop)()) {
    return 'isDesktop';
  }
  return (0, _ua.getIsTablet)() ? 'isTablet' : 'isMobile';
}

(0, _dom.classList)(document.body).add(getDeviceTypeClass(), (0, _ua.getBrowserClassName)());

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdkLoaded = exports.loadSdk = exports.MONTIPLAYER_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var MONTIPLAYER_ACTION_TYPES = exports.MONTIPLAYER_ACTION_TYPES = (0, _object.namespacedConsts)({
  SDK_LOADED: true,
  LOAD_SDK: true
});

var loadSdk = exports.loadSdk = function loadSdk(_) {
  return {
    type: MONTIPLAYER_ACTION_TYPES.LOAD_SDK
  };
};

var sdkLoaded = exports.sdkLoaded = function sdkLoaded(_) {
  return {
    type: MONTIPLAYER_ACTION_TYPES.SDK_LOADED
  };
};

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LeagueSelection;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var blockName = 'league-selection-component';

function getLeagueNameSelectionOption(leagueName) {
  var optionProps = {
    key: leagueName,
    value: leagueName,
    children: leagueName,
    className: blockName + '__option'
  };
  return _react2.default.createElement('option', optionProps);
}

function LeagueSelection(_ref) {
  var modifier = _ref.modifier,
      leagueNames = _ref.leagues,
      currentLeague = _ref.currentLeague,
      onChangeLeagueHandler = _ref.onChangeLeagueHandler;

  var containerClassName = modifier ? blockName + ' ' + blockName + '--' + modifier : blockName;
  return _react2.default.createElement(
    'div',
    { className: containerClassName },
    _react2.default.createElement(
      'h4',
      { className: blockName + '__title' },
      (0, _i18nProvider.t)('homepage.schedule')
    ),
    _react2.default.createElement(
      'div',
      { className: blockName + '__wrapper' },
      _react2.default.createElement(
        'select',
        {
          value: currentLeague,
          onChange: onChangeLeagueHandler,
          className: blockName + '__league-selection'
        },
        leagueNames.map(getLeagueNameSelectionOption)
      )
    )
  );
}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchWithResult;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'match-result-component';
var teamScoreElement = 'team-score';

function MatchWithResult(_ref) {
  var result = _ref.result;

  return _react2.default.createElement(
    'div',
    { className: blockName + '__container' },
    _react2.default.createElement(
      'span',
      { className: blockName + '__' + teamScoreElement + ' ' + blockName + '__' + teamScoreElement + '--home' },
      result.home
    ),
    _react2.default.createElement(
      'span',
      { className: blockName + '__seperator' },
      ':'
    ),
    _react2.default.createElement(
      'span',
      { className: blockName + '__' + teamScoreElement + ' ' + blockName + '__' + teamScoreElement + '--away' },
      result.away
    )
  );
}

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Team;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'team-component';
function Team(_ref) {
  var name = _ref.name,
      image = _ref.image,
      isHome = _ref.isHome;

  var isHomeClass = isHome ? 'home' : 'away';
  var classNames = blockName + ' ' + blockName + '--' + isHomeClass;
  return _react2.default.createElement(
    'div',
    { className: classNames },
    _react2.default.createElement(
      'div',
      { className: blockName + '__image-container' },
      _react2.default.createElement('img', { src: image, alt: name, className: blockName + '__image' })
    ),
    _react2.default.createElement(
      'p',
      { className: blockName + '__name' },
      name
    )
  );
}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

exports.getLeagueId2Name = getLeagueId2Name;
exports.getLeagueName2Id = getLeagueName2Id;
exports.getLeagueNames = getLeagueNames;

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLeagueId2Name() {
  return (0, _pageDataObject.getLeaguesForFixtures)().reduce(function (accumulator, curr) {
    return (0, _extends5.default)({}, accumulator, (0, _defineProperty3.default)({}, curr.id, curr.name));
  }, {});
}
function getLeagueName2Id() {
  return (0, _pageDataObject.getLeaguesForFixtures)().reduce(function (accumulator, curr) {
    return (0, _extends5.default)({}, accumulator, (0, _defineProperty3.default)({}, curr.name, curr.id));
  }, {});
}
function getLeagueNames() {
  return (0, _pageDataObject.getLeaguesForFixtures)().map(function (leagueData) {
    return leagueData.name;
  });
}

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoAdsTag = getVideoAdsTag;

var _adTargeting = __webpack_require__(85);

function getVideoAdsTag() {
  window.getVideoTag = _adTargeting.getVideoTag;
}

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_PLAYLIST = exports.RECEIVED_RECOMMENDATIONS_DATA_ERROR = exports.RECEIVED_RECOMMENDATIONS_DATA = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.receivedRecommedationsAction = receivedRecommedationsAction;
exports.receivedErrorAction = receivedErrorAction;
exports.setPlaylistId = setPlaylistId;
exports.newVideoLoaded = newVideoLoaded;

var _recommendedVideos = __webpack_require__(321);

var _appStore = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECEIVED_RECOMMENDATIONS_DATA = exports.RECEIVED_RECOMMENDATIONS_DATA = 'RECEIVED_RECOMMENDATIONS_DATA';
var RECEIVED_RECOMMENDATIONS_DATA_ERROR = exports.RECEIVED_RECOMMENDATIONS_DATA_ERROR = 'RECEIVED_RECOMMENDATIONS_DATA_ERROR';
var SET_PLAYLIST = exports.SET_PLAYLIST = 'SET_PLAYLIST';

function receivedRecommedationsAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA,
    payload: (0, _extends3.default)({}, payload, {
      isInitialized: true,
      recievedError: false
    })
  };
}

function receivedErrorAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA_ERROR,
    payload: {
      isInitialized: false,
      recievedError: true
    }
  };
}

function setPlaylistId(playlist) {
  return {
    type: SET_PLAYLIST,
    payload: playlist
  };
}

function payloadMapper(playerId, item) {
  item.hlink = '/videos/' + playerId + '/' + item.mediaId;
  return item;
}

function normalizePayload(playerId, payload) {
  var recommendedItemsMapper = payloadMapper.bind(null, playerId);
  return {
    recommendedItems: payload.map(recommendedItemsMapper)
  };
}

function dispatchNormalizedVideoPaylaod(payload) {
  return (0, _appStore.dispatch)(receivedRecommedationsAction(payload));
}

function dispatchReceivedError(payload) {
  return (0, _appStore.dispatch)(receivedErrorAction(payload));
}

function newVideoLoaded(providerName, playerId, videoId) {
  var normalizeVideoPayload = normalizePayload.bind(null, playerId);
  (0, _recommendedVideos.getDataByProvider)({ providerName: providerName, playlistId: (0, _appStore.getState)().recommendedVideos.playlistId, videoId: videoId }).then(normalizeVideoPayload).then(dispatchNormalizedVideoPaylaod).catch(dispatchReceivedError);
}

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinksGroupContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getPath = getPath;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT = '/';

function getPath() {
  return typeof window !== 'undefined' ? window.location.pathname : ROOT;
}

var LinksGroupContainer = exports.LinksGroupContainer = function (_Component) {
  (0, _inherits3.default)(LinksGroupContainer, _Component);

  function LinksGroupContainer(props) {
    (0, _classCallCheck3.default)(this, LinksGroupContainer);
    return (0, _possibleConstructorReturn3.default)(this, (LinksGroupContainer.__proto__ || (0, _getPrototypeOf2.default)(LinksGroupContainer)).call(this, props));
  }

  (0, _createClass3.default)(LinksGroupContainer, [{
    key: 'specific',
    value: function specific(link) {
      if (link.slug !== null) {
        return this.props.block_name + '__list-item' + link.slug;
      }
      return '';
    }
  }, {
    key: 'shouldRemoveLink',
    value: function shouldRemoveLink(link) {
      var path = getPath().split('/').pop();
      return this.props.remove_selected && path !== '/' && link.slug === path;
    }
  }, {
    key: 'getLinkItem',
    value: function getLinkItem(link, index) {
      return _react2.default.createElement(
        'li',
        { key: index, className: this.props.block_name + '__list-item ' + this.specific(link) },
        _react2.default.createElement(
          'a',
          {
            title: link.title,
            href: link.url,
            target: this.props.target,
            className: link.class_name_for_list_item_anchor,
            'data-analytics-event-category': this.props.analytics_event_category,
            'data-analytics-event-action': this.props.analytics_event_action,
            'data-analytics-event-label': link.analytics_event_label_at
          },
          link.image ? _react2.default.createElement('img', {
            src: link.image,
            alt: link.title,
            className: this.props.block_name + '__list-item-image'
          }) : null,
          link.title ? link.title : ''
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'section',
        {
          className: this.props.block_name + '  ' + this.props.block_name + '--' + this.props.modifier
        },
        this.props.header_text ? _react2.default.createElement(
          'h3',
          { className: this.props.block_name + '__title' },
          this.props.header_text
        ) : null,
        _react2.default.createElement(
          'ul',
          { className: this.props.block_name + '__list' },
          this.props.links.map(function (link, index) {
            return _this2.shouldRemoveLink(link) ? null : _this2.getLinkItem(link, index);
          })
        )
      );
    }
  }]);
  return LinksGroupContainer;
}(_react.Component);

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.getAnalyticsPageType = getAnalyticsPageType;
exports.getVideoPostWrapperName = getVideoPostWrapperName;
exports.calculateVideoTimePercent = calculateVideoTimePercent;

var _dom = __webpack_require__(13);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAnalyticsPageType() {
  var optionalPageTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var analyticsPageType = (0, _assign2.default)({
    homepage: 'Home page',
    post: 'Article page',
    video_page: 'Video page', // eslint-disable-line camelcase
    hubs: 'Partner page'
  }, optionalPageTypes);

  return analyticsPageType[_pageDataObject2.default.getPageType()] || 'cant get pagetype from pdo';
}

function getVideoPostWrapperName(playerRef) {
  var analyticsWrappersDescription = {
    'post-cover': 'cover',
    'post-body-wrap': 'body'
  };

  var articleSectionVideoWrapper = (0, _dom.parentElementUntil)(function (ancestorWrapper) {
    return ancestorWrapper.classList.contains('post-cover') || ancestorWrapper.classList.contains('post-body-wrap');
  });

  var postAncestorNode = articleSectionVideoWrapper(playerRef);
  var wrapperName = 'no wrapper';

  return postAncestorNode ? (0, _keys2.default)(analyticsWrappersDescription).reduce(function (acc, currentValue) {
    return postAncestorNode.classList.contains(currentValue) ? analyticsWrappersDescription[currentValue] : acc;
  }, wrapperName) : wrapperName;
}

function calculateVideoTimePercent(duration, currentTime) {
  var videoPercentageStops = [5, 25, 50, 75, 90];
  var computedVideoStepPercentage = Math.round(currentTime / (duration / 100));

  return videoPercentageStops.indexOf(computedVideoStepPercentage) !== -1 ? computedVideoStepPercentage : false;
}

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(126);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _string = __webpack_require__(47);

var _window = __webpack_require__(8);

var _analyticsStore = __webpack_require__(51);

var _analyticsStore2 = _interopRequireDefault(_analyticsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var AnalyticsBaseService = function (_BaseVm) {
  (0, _inherits3.default)(AnalyticsBaseService, _BaseVm);

  function AnalyticsBaseService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AnalyticsBaseService);

    options.store = options.store || _analyticsStore2.default.create();

    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsBaseService.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsBaseService)).call(this, options));

    _this.state.reportOnce = {};
    _this.facebookShare = _this.twitterShare = _this.whatsappShare = _this.socialShare;
    return _this;
  }

  (0, _createClass3.default)(AnalyticsBaseService, [{
    key: 'onChange',
    value: function onChange(action) {
      var legacyActionHandlerName = (0, _string.toCamelCase)(action.type.split(':').pop());
      var actionHandlerName = action.analyticsActionName;
      var actionHandler = this[legacyActionHandlerName] || this[actionHandlerName];
      if (actionHandler instanceof Function) {
        actionHandler.bind(this)(action);
      }
    }
  }, {
    key: 'logAnalytics',
    value: function logAnalytics() {
      if (_window.queryString.showAnalytics) {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.info('tracking ' + this.className + ': ', args);
      }
    }
  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {
      this.pageViewed();
    }

    // NOTICE - to identify an action and determine if it was already reported,
    // it does JSON.stringify(action) and uses that as key
    // if an action has properties that contain objects (and not just primitive values)
    // this may not work properly!

  }, {
    key: 'reportOnce',
    value: function reportOnce(action, reportMethod) {
      var reporter = this.className;
      this.state.reportOnce[reporter] = this.state.reportOnce[reporter] || {};
      var actionId = (0, _stringify2.default)(action);
      var wasReported = this.state.reportOnce[reporter][actionId];
      if (!wasReported) {
        reportMethod();
        this.state.reportOnce[reporter][actionId] = true;
      }
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {}
  }, {
    key: 'socialShare',
    value: function socialShare() {}
  }, {
    key: 'className',
    get: function get() {
      return 'AnalyticsBaseService';
    }
  }]);
  return AnalyticsBaseService;
}(_BaseVm3.default);

exports.default = AnalyticsBaseService;

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initMontiPlayers;

var _dom = __webpack_require__(13);

var _reactRedux = __webpack_require__(37);

var _string = __webpack_require__(47);

var _reactDom = __webpack_require__(116);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _montiplayerActions = __webpack_require__(198);

var montiplayerActions = _interopRequireWildcard(_montiplayerActions);

var _reactUtils = __webpack_require__(86);

var _script = __webpack_require__(19);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _spinner = __webpack_require__(309);

var _externalScripts = __webpack_require__(52);

var _recommendedVideos = __webpack_require__(223);

var _video = __webpack_require__(251);

var _montiReducer = __webpack_require__(292);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function shouldSendMontiTagServerUrl() {
  return _pageDataObject2.default.ads.property !== 'EI';
}

var MontiPlayerContainerComponent = function (_Component) {
  (0, _inherits3.default)(MontiPlayerContainerComponent, _Component);

  function MontiPlayerContainerComponent(props) {
    (0, _classCallCheck3.default)(this, MontiPlayerContainerComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MontiPlayerContainerComponent.__proto__ || (0, _getPrototypeOf2.default)(MontiPlayerContainerComponent)).call(this, props));

    (0, _assign2.default)(_this, {
      id: 'ID' + (0, _string.randId)(),
      initPlayer: _this.initPlayer.bind(_this)
    });
    return _this;
  }

  (0, _createClass3.default)(MontiPlayerContainerComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          isInitialized = _props.isInitialized,
          sdkLoadingState = _props.sdkLoadingState,
          loadSdk = _props.loadSdk,
          sdkLoaded = _props.sdkLoaded,
          options = _props.options;

      this.dataset = options.dataset;
      if (!isInitialized && !sdkLoadingState) {
        loadSdk();
        var src = _pageDataObject2.default.getPostId() === 6346773 ? _externalScripts.externalScriptsConfig.montiSEOtest.src(this.dataset.player_id) : _externalScripts.externalScriptsConfig.monti.src(this.dataset.player_id);
        _script.external.load({
          config: {
            src: src,
            name: 'montiApiPlayer'
          }
        })(sdkLoaded);
      }
    }
  }, {
    key: 'initPlayer',
    value: function initPlayer(playerRef) {
      var _this2 = this;

      //media_id calculation with the if is a hack to support the VMS - this won't appear in the new site so once 90min makes the transition this code is dead
      var media_id = void 0;
      if (this.dataset.player_id.startsWith('01')) {
        media_id = this.dataset.player_id;
      } else {
        media_id = this.dataset.video_id;
      }
      var montiConfig = this.montiSetupBaseConfig(playerRef, media_id);
      this.setupMontiPlayer(montiConfig).then(function (player) {
        (0, _recommendedVideos.newVideoLoaded)('jw', _this2.dataset.player_id, media_id);
        _this2.onMontiSetup(player, media_id);
      }).catch(function () {
        return (0, _recommendedVideos.newVideoLoaded)('jw', _this2.dataset.player_id, media_id);
      });
    }
  }, {
    key: 'montiSetupBaseConfig',
    value: function montiSetupBaseConfig(playerRef, media_id) {
      var playerPos = (0, _reactDom.findDOMNode)(playerRef);
      playerPos.style.marginTop = '-16px'; // HACK: solve in MPlayer - shouldn't add margin
      return {
        config_name: 'Editor Embedded player in ' + _pageDataObject2.default.getSiteDomainWithTld(),
        uniq_key: 'mm-article-player',
        publisher_contribution: _pageDataObject2.default.getSiteDomainWithTld(),
        content_id: media_id,
        content_type: media_id.startsWith('01') ? 'specific' : 'curated',
        player_pos: playerPos,
        category_name: (0, _video.getAnalyticsPageType)(),
        monetization: {
          vpaid_mode: 'ENABLED',
          strategy: 'on_player_load',
          ad_type: 'auto_dynamic_tag',
          ad_request_timeout: '10000',
          ad_break_slots: {
            on: [0]
          }
        },
        brand_color: '#EEEEEE',
        playback_method: 'none',
        powered_by_strip: false
      };
    }
  }, {
    key: 'setupMontiPlayer',
    value: function setupMontiPlayer(montiConfig) {
      var monti = window.monti();
      if (shouldSendMontiTagServerUrl()) {
        return monti.initiate(montiConfig);
      }
      return monti.initiate((0, _extends3.default)({}, montiConfig, {
        monetization: {
          ad_type: 'jw_scheduler'
        }
      }));
    }
  }, {
    key: 'onMontiSetup',
    value: function onMontiSetup(player, media_id) {
      var _this3 = this;

      player.on('loadstart', function () {
        (0, _recommendedVideos.newVideoLoaded)('jw', _this3.dataset.player_id, player.getConfig().playlistItem.mediaid || media_id);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isPlayerInitalized = this.props.isInitialized;
      return isPlayerInitalized ? _react2.default.createElement('div', { id: this.id, ref: this.initPlayer }) : _react2.default.createElement(_spinner.Spinner, { isInitialized: isPlayerInitalized, contrastModifier: this.dataset.contrast });
    }
  }]);
  return MontiPlayerContainerComponent;
}(_react.Component);

var COMPONENT_NAME = 'montiplayerContainer';

function mapStateToProps(state) {
  return {
    isInitialized: (0, _montiReducer.isInitializedSelector)(state),
    sdkLoadingState: (0, _montiReducer.sdkLoadingStateSelector)(state)
  };
}

var montiContainer = {
  name: COMPONENT_NAME,
  stateKey: _montiReducer.STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, montiplayerActions)((0, _reactUtils.withParentAttributesAsProps)(MontiPlayerContainerComponent)),
  reducer: _montiReducer.montiReducer
};

function shouldMountMontiPlayer() {
  return (0, _dom.nodes)(_preRenderedSelectorsConfig.MOUNT_POINTS.MONTI_BODY).length !== 0;
}

function initMontiPlayers() {
  if (!shouldMountMontiPlayer()) {
    return false;
  }
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.MONTI_BODY, montiContainer));
}

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE_KEY = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _handlers;

exports.isInitializedSelector = isInitializedSelector;
exports.sdkLoadingStateSelector = sdkLoadingStateSelector;
exports.montiReducer = montiReducer;

var _montiplayerActions = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATE_KEY = exports.STATE_KEY = 'montiplayer';

var INITIAL_STATE = {
  players: [],
  isInitialized: false,
  sdkLoading: false
};

function sdkLoaded(state) {
  return (0, _extends3.default)({}, state, { isInitialized: true });
}

function sdkStartLoading(state) {
  return (0, _extends3.default)({}, state, { sdkLoading: true });
}

var handlers = (_handlers = {}, (0, _defineProperty3.default)(_handlers, _montiplayerActions.MONTIPLAYER_ACTION_TYPES.SDK_LOADED, sdkLoaded), (0, _defineProperty3.default)(_handlers, _montiplayerActions.MONTIPLAYER_ACTION_TYPES.LOAD_SDK, sdkStartLoading), _handlers);

function isInitializedSelector(state) {
  return state[STATE_KEY].isInitialized;
}

function sdkLoadingStateSelector(state) {
  return state[STATE_KEY].sdkLoading;
}

function montiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  return handlers[action.type] && handlers[action.type](state, action.payload) || state;
}

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = Spinner;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initSpinner(contrastModifier) {
  return _react2.default.createElement('div', { className: contrastModifier ? 'spinner spinner--' + contrastModifier : 'spinner' });
}

function Spinner(_ref) {
  var isInitialized = _ref.isInitialized,
      contrastModifier = _ref.contrastModifier;

  return isInitialized ? _react2.default.createElement('noscript', null) : initSpinner(contrastModifier);
}

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tvScheduleActions = exports.TV_SCHEDULE_ACTION_TYPES = exports.API_ENDPOINT_NAME = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.fetchData = fetchData;
exports.setLoading = setLoading;
exports.changeSelectedChannelName = changeSelectedChannelName;
exports.changeTvScheduleDate = changeTvScheduleDate;

var _fn = __webpack_require__(15);

var _object = __webpack_require__(12);

var _api = __webpack_require__(123);

var _fetchSaga = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var API_ENDPOINT_NAME = exports.API_ENDPOINT_NAME = 'TV_SCHEDULE';

var TV_SCHEDULE_ACTION_TYPES = exports.TV_SCHEDULE_ACTION_TYPES = (0, _extends3.default)({}, (0, _object.namespacedConsts)({
  CHANGE_TV_SCHEDULE_DATE: true,
  CHANGE_SELECTED_CHANNEL_NAME: true,
  LOADING_DATA: true
}), (0, _fn.memoizeFirstCall)('TV_SCHEDULE_ACTION_TYPES', _fetchSaga.getNamespacedFetchActionTypes, API_ENDPOINT_NAME).TV_SCHEDULE_ACTION_TYPES);

var CHANGE_SELECTED_CHANNEL_NAME = TV_SCHEDULE_ACTION_TYPES.CHANGE_SELECTED_CHANNEL_NAME,
    CHANGE_TV_SCHEDULE_DATE = TV_SCHEDULE_ACTION_TYPES.CHANGE_TV_SCHEDULE_DATE,
    LOADING_DATA = TV_SCHEDULE_ACTION_TYPES.LOADING_DATA;
function fetchData(dataTransformer, date) {
  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('TV_SCHEDULE_ACTION_TYPES', _api.getApiEndpoints, API_ENDPOINT_NAME),
      _memoizeFirstCall$TV_ = _memoizeFirstCall.TV_SCHEDULE_ACTION_TYPES,
      url = _memoizeFirstCall$TV_.url,
      endpointName = _memoizeFirstCall$TV_.endpointName;

  var urlWithParams = url + '/' + date + '.json';

  return function (dispatch, getState) {
    return dispatch({
      type: _fetchSaga.FETCH_REQUEST_ACTION_TYPE,
      payload: {
        url: urlWithParams,
        endpointName: endpointName,
        dataTransformer: dataTransformer,
        additionalState: {
          IS_INITIALIZED: true,
          IS_LOADING: false
        }
      }
    });
  };
}

function setLoading() {
  return function (dispatch, getState) {
    return dispatch({
      type: LOADING_DATA,
      state: {
        IS_LOADING: true
      }
    });
  };
}

function changeSelectedChannelName(selectedChannelName) {
  return function (dispatch, getState) {
    return dispatch({
      type: CHANGE_SELECTED_CHANNEL_NAME,
      state: {
        currentChannelName: selectedChannelName
      }
    });
  };
}

function changeTvScheduleDate(newDate) {
  return function (dispatch, getState) {
    return dispatch({
      type: CHANGE_TV_SCHEDULE_DATE,
      state: {
        scheduleDate: newDate
      }
    });
  };
}

var tvScheduleActions = exports.tvScheduleActions = {
  fetchData: fetchData, changeSelectedChannelName: changeSelectedChannelName, changeTvScheduleDate: changeTvScheduleDate
};

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataByProvider = getDataByProvider;

var _fetch = __webpack_require__(57);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var featureFlags = {
  debug: _window.queryString.debugRecommendedVideos
};

function warn() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  featureFlags.debug && _console.info.apply(undefined, ['[recommended videos]'].concat(args));
}

var dataProviders = {
  jw: function jw(_ref) {
    var providerName = _ref.providerName,
        playlistId = _ref.playlistId,
        videoId = _ref.videoId;

    return (0, _fetch.getJsonOrError)('https://cdn.jwplayer.com/v2/playlists/' + playlistId + '?related_media_id=' + videoId + '&page_limit=5').then(function (data) {
      warn({ providerName: providerName, data: data });
      return data;
    });
  },
  yt: function yt(providerConf) {
    return 'provider: youtube';
  }
};

function mapOverRecommendedPlaylist(item, idx) {
  return {
    id: idx,
    title: item.title,
    mediaId: item.mediaid,
    description: item.description || 'no description',
    image: item.image,
    hlink: item.link
  };
}

function parseRecommendedData(data) {
  return data && data.playlist && data.playlist.map(mapOverRecommendedPlaylist);
}

function getDataByProvider(providerConf) {
  switch (providerConf.providerName) {
    case 'jw':
      return dataProviders.jw(providerConf).then(parseRecommendedData);
    case 'yt':
      return dataProviders.yt(providerConf).then(parseRecommendedData);
    default:
      return warn('no provider configuration was supplied to recommendatioList');
  }
}

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectDestructuringEmpty2 = __webpack_require__(226);

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

exports.default = PreloadScores;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _emptyMatchScores = __webpack_require__(681);

var _emptyMatchScores2 = _interopRequireDefault(_emptyMatchScores);

var _array = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'preload-scores';

var NUM_ROWS_IN_PRELOAD = 3;
function PreloadScores(_ref) {
  (0, _objectDestructuringEmpty3.default)(_ref);

  var listClassNames = [blockName + '__list', blockName + '__list--loading'].join(' ');
  var rows = (0, _array.range)(NUM_ROWS_IN_PRELOAD).map(function (_, i) {
    return _react2.default.createElement(_emptyMatchScores2.default, { blockName: blockName, key: i });
  });
  return _react2.default.createElement(
    'div',
    { className: blockName },
    _react2.default.createElement(
      'div',
      { className: blockName + '__wrapper' },
      _react2.default.createElement('h2', { className: blockName + '__header' }),
      _react2.default.createElement(
        'ul',
        { className: listClassNames },
        rows
      )
    )
  );
}

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ScheduleDayPager;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _date = __webpack_require__(181);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'fixtures-schedule-navigation'; /* eslint semi:0 */


function ChangeDayButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      text = _ref.text;

  var changeDayButtonProps = {
    className: className,
    onClick: onClick,
    title: text,
    children: text
  };
  return _react2.default.createElement('button', changeDayButtonProps);
}

function ScheduleDayPager(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === undefined ? '' : _ref2$className,
      onMoveToNextDay = _ref2.onMoveToNextDay,
      onMoveToPrevDay = _ref2.onMoveToPrevDay,
      currentDay = _ref2.currentDay,
      minDate = _ref2.minDate,
      maxDate = _ref2.maxDate;

  var day = currentDay.getDate();
  var monthNumber = currentDay.getMonth() + 1;
  var monthNamesAbbr = (0, _i18nProvider.t)('date.abbr_month_names');
  var monthShortName = monthNamesAbbr[monthNumber];
  var year = currentDay.getFullYear();
  var disableNext = currentDay >= maxDate;
  var disablePrev = currentDay <= minDate;

  var prevDayButtonProps = {
    className: [blockName + '__prev-day', disablePrev ? blockName + '__prev-day--disabled' : ''].join(' '),
    onClick: onMoveToPrevDay,
    text: (0, _i18nProvider.t)('common.prev')
  };
  var nextDayButtonProps = {
    className: [blockName + '__next-day', disableNext ? blockName + '__next-day--disabled' : ''].join(' '),
    onClick: onMoveToNextDay,
    text: (0, _i18nProvider.t)('common.next')
  };
  var timeProps = {
    dateTime: (0, _date.toIsoStringDate)(currentDay),
    className: blockName + '__current-day-display',
    children: day + '-' + monthShortName + '-' + year
  };
  return _react2.default.createElement(
    'header',
    { className: [className, blockName].join(' ') },
    _react2.default.createElement(ChangeDayButton, prevDayButtonProps),
    _react2.default.createElement('time', timeProps),
    _react2.default.createElement(ChangeDayButton, nextDayButtonProps)
  );
}

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scoresTableActions = exports.API_ENDPOINT_NAME = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

exports.fetchScoresTables = fetchScoresTables;

var _fn = __webpack_require__(15);

var _api = __webpack_require__(123);

var _pageDataObject = __webpack_require__(5);

var _fetchSaga = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var API_ENDPOINT_NAME = exports.API_ENDPOINT_NAME = 'SCORES_TABLES';

function filterTablesBasedOnLeaguesForFixtures(leagueTable) {
  var leagueIdsFromEdition = (0, _pageDataObject.getLeaguesForFixtures)().map(function (league) {
    return league.id;
  });
  return leagueIdsFromEdition.includes(+leagueTable.league.id);
}

function reduceToScoreTablesByLeagueIdMap(acc, table) {
  return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, table.league.id, table));
}

function dataTransformer(_ref) {
  var tables = _ref.tables;

  var scoresTableList = tables.filter(filterTablesBasedOnLeaguesForFixtures).reduce(reduceToScoreTablesByLeagueIdMap, {});
  return {
    tables: scoresTableList
  };
}

function fetchScoresTables() {
  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('scoresTableEndpoint', _api.getApiEndpoints, API_ENDPOINT_NAME),
      _memoizeFirstCall$sco = _memoizeFirstCall.scoresTableEndpoint,
      url = _memoizeFirstCall$sco.url,
      endpointName = _memoizeFirstCall$sco.endpointName;

  return function (dispatch, getState) {
    return dispatch({
      type: _fetchSaga.FETCH_REQUEST_ACTION_TYPE,
      payload: {
        url: url,
        endpointName: endpointName,
        dataTransformer: dataTransformer,
        additionalState: {
          IS_INITIALIZED: true
        }
      }
    });
  };
}

var scoresTableActions = exports.scoresTableActions = { fetchScoresTables: fetchScoresTables };

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TvScheduleChannelSelection = exports.TV_SCHEDULE_COMPONENT_STATE_KEY = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initTvChannelSelection;

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _date = __webpack_require__(181);

var _i18nProvider = __webpack_require__(18);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _TvChannelSelection = __webpack_require__(697);

var _TvChannelSelection2 = _interopRequireDefault(_TvChannelSelection);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

var _fetchSaga = __webpack_require__(56);

var _tvScheduleActions = __webpack_require__(310);

var _tvChannelSelectionReducer = __webpack_require__(416);

var _tvChannelSelectionReducer2 = _interopRequireDefault(_tvChannelSelectionReducer);

var _tvScheduleEmptyDay = __webpack_require__(417);

var _tvScheduleContainer = __webpack_require__(418);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TV_SCHEDULE_COMPONENT_STATE_KEY = exports.TV_SCHEDULE_COMPONENT_STATE_KEY = 'tvScheduleComponent'; /* eslint semi:0 */

var TV_SCHEDULE_CHANNEL_SELECTION_COMPONENT_NAME = 'TvScheduleChannelSelection';

var blockName = 'tv-channel-selection';

function TvScheduleWatchMoreButton(props) {
  var url = _tvScheduleEmptyDay.defaultChannels[props.currentChannelName] && _tvScheduleEmptyDay.defaultChannels[props.currentChannelName].channelUrl;
  var className = props.blockName + '__button-watch-more';
  return _react2.default.createElement(
    'a',
    { className: className, target: '_blank', href: url },
    (0, _i18nProvider.t)('pages.tv_programming.watch_now')
  );
}

var TvScheduleChannelSelection = exports.TvScheduleChannelSelection = function (_Component) {
  (0, _inherits3.default)(TvScheduleChannelSelection, _Component);

  function TvScheduleChannelSelection() {
    (0, _classCallCheck3.default)(this, TvScheduleChannelSelection);
    return (0, _possibleConstructorReturn3.default)(this, (TvScheduleChannelSelection.__proto__ || (0, _getPrototypeOf2.default)(TvScheduleChannelSelection)).apply(this, arguments));
  }

  (0, _createClass3.default)(TvScheduleChannelSelection, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          IS_ENTRY_POINT_MISSING = _props.IS_ENTRY_POINT_MISSING,
          IS_INITIALIZED = _props.IS_INITIALIZED,
          IS_LOADING = _props.IS_LOADING,
          dispatch = _props.dispatch;

      if (IS_ENTRY_POINT_MISSING) {
        return (0, _fetchSaga.getNoEndpointsErrorMessage)(this);
      }
      if (!IS_INITIALIZED) {
        return dispatch((0, _tvScheduleActions.fetchData)(_tvChannelSelectionReducer.transformTvChannelsData, (0, _date.getCurrentIsoStringDate)()));
      }
      return this;
    }
  }, {
    key: 'onChangeSelection',
    value: function onChangeSelection(e) {
      var selectedChannelName = e.target.value;

      this.props.dispatch((0, _tvScheduleActions.changeSelectedChannelName)(selectedChannelName));
    }
  }, {
    key: 'render',
    value: function render() {
      var onChangeSelection = this.onChangeSelection,
          _props2 = this.props,
          currentChannelName = _props2.currentChannelName,
          channelNames = _props2.channelNames;

      var tvChannelSelectionProps = {
        selected: currentChannelName,
        entityName: 'tv-channel',
        available: channelNames,
        onChange: onChangeSelection.bind(this),
        blockName: blockName
      };
      return _react2.default.createElement(
        'div',
        { className: blockName + '__container' },
        _react2.default.createElement(_TvChannelSelection2.default, tvChannelSelectionProps),
        _react2.default.createElement(TvScheduleWatchMoreButton, { blockName: blockName, currentChannelName: currentChannelName })
      );
    }
  }]);
  return TvScheduleChannelSelection;
}(_react.Component);

var TvScheduleChannelSelectionContainer = {
  name: TV_SCHEDULE_CHANNEL_SELECTION_COMPONENT_NAME,
  stateKey: TV_SCHEDULE_COMPONENT_STATE_KEY,
  component: (0, _reactRedux.connect)(_tvScheduleContainer.mapStateToProps)(TvScheduleChannelSelection),
  reducer: _tvChannelSelectionReducer2.default
};

function mountTvScheduleChannelSelection() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.TV_SCHEDULE_CHANNEL_SELECTION, TvScheduleChannelSelectionContainer));
}

var TV_SCHEDULE_FEATURE_ID = 'TvSchedule';

function initTvChannelSelection() {
  var shouldMountTvScheduleChannelSelection = (0, _pageDataObject.isSupportedForDomain)(TV_SCHEDULE_FEATURE_ID);
  if (shouldMountTvScheduleChannelSelection) {
    mountTvScheduleChannelSelection();
  }
  return shouldMountTvScheduleChannelSelection;
}

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.transformTvChannelsData = transformTvChannelsData;
exports.default = tvChannelSelectionReducer;

var _window = __webpack_require__(8);

var _tvScheduleActions = __webpack_require__(310);

var _date = __webpack_require__(181);

var _tvScheduleEmptyDay = __webpack_require__(417);

var _tvScheduleEmptyDay2 = _interopRequireDefault(_tvScheduleEmptyDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//should use default empty schedule from server - TBD by Eddy, then will change

/* eslint semi:0 */
var TV_SCHEDULE_DAYS_RANGE = 15;

function getPossiblyOverridenDate() {
  var tvScheduleDate = _window.queryString.tvScheduleDate;

  return tvScheduleDate ? new Date(tvScheduleDate) : new Date();
}

function getDefaultState() {
  return {
    channels: [],
    channelNames: [],
    currentChannel: {},
    IS_INITIALIZED: false,
    IS_LOADING: true,
    currentChannelName: '',
    get scheduleDate() {
      return getPossiblyOverridenDate();
    },
    get minDate() {
      return (0, _date.addDaysToDate)(new Date(), -2 * TV_SCHEDULE_DAYS_RANGE);
    },
    get maxDate() {
      return (0, _date.addDaysToDate)(new Date(), TV_SCHEDULE_DAYS_RANGE);
    }
  };
}

function setState(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

function sortScheduleDays(dayA, dayB) {
  return new Date(dayA.date) - new Date(dayB.date);
}

function sortChannelSchedule(channelData) {
  return channelData.schedule.sort(sortScheduleDays);
}

function handleNonExistingScheduleData(state) {
  var newState = mergeScheduleData(state, fillDataWithDate(_tvScheduleEmptyDay2.default, state.scheduleDate));
  return transformTvChannelsData(newState);
}

function fillDataWithDate(data, scheduleDate) {
  data.channels.forEach(function (channel) {
    return channel.schedule[0].date = (0, _date.toIsoStringDate)(scheduleDate);
  });
  return data;
}

function mergeScheduleData(state, scheduleData) {
  var channels = scheduleData.channels.reduce(reduceChannelsData, state.channels);
  channels.forEach(sortChannelSchedule);
  return (0, _extends3.default)({}, state, scheduleData, { channels: channels, IS_INITIALIZED: true, IS_LOADING: false });
}

function reduceChannelsData(accumChannelsData, newChannelData) {
  var newChannel = newChannelData.channel,
      newSchedule = newChannelData.schedule;

  var existingChannelData = accumChannelsData.find(function (_ref) {
    var channel = _ref.channel;
    return channel.name === newChannel.name;
  });
  var dateExists = existingChannelData ? existingChannelData.schedule.some(function (dayShows) {
    return dayShows.date === newSchedule[0].date;
  }) : false;
  !dateExists && !existingChannelData && accumChannelsData.push(newChannelData);
  !dateExists && existingChannelData && existingChannelData.schedule.push(newSchedule[0]);
  return accumChannelsData;
}

function reduceChannelNames(channelNames, _ref2) {
  var channel = _ref2.channel;

  return [].concat((0, _toConsumableArray3.default)(channelNames), [channel.name]);
}

function transformTvChannelsData(state) {
  var channelNames = state.channelNames && state.channelNames.length ? state.channelNames : state.channels.reduce(reduceChannelNames, []);
  return (0, _extends3.default)({}, state, {
    channelNames: channelNames,
    currentChannelName: state.currentChannel.name
  });
}

function tvChannelSelectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments[1];

  if (_tvScheduleActions.TV_SCHEDULE_ACTION_TYPES) {
    switch (action.type) {
      case _tvScheduleActions.TV_SCHEDULE_ACTION_TYPES.FETCH.SUCCESS:
        return mergeScheduleData(state, action.state);
      case _tvScheduleActions.TV_SCHEDULE_ACTION_TYPES.FETCH.FAIL:
        return handleNonExistingScheduleData(state);
      case _tvScheduleActions.TV_SCHEDULE_ACTION_TYPES.CHANGE_SELECTED_CHANNEL_NAME:
      case _tvScheduleActions.TV_SCHEDULE_ACTION_TYPES.CHANGE_TV_SCHEDULE_DATE:
      case _tvScheduleActions.TV_SCHEDULE_ACTION_TYPES.LOADING_DATA:
        return setState(state, action.state);
      default:
        return state;
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true });
}

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultChannels = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultChannels = exports.defaultChannels = {
  'Esporte Interativo': {
    channelUrl: 'https://www.eiplus.com.br/assinatura/?utm_source=Portal&utm_medium=PgProgramacao&utm_campaign=EI_0_Canal&utm_content=Assine_0_11880_PA_0_6_Retangulo'
  },
  'Esporte Interativo 2': {
    channelUrl: 'https://www.eiplus.com.br/assinatura/?utm_source=Portal&utm_medium=PgProgramacao&utm_campaign=EI2_0_Canal&utm_content=Assine_0_11880_PA_0_6_Retangulo'
  },
  'Esporte Interativo BR': {
    channelUrl: 'https://www.eiplus.com.br/assinatura/?utm_source=Portal&utm_medium=PgProgramacao&utm_campaign=EIBR_0_Canal&utm_content=Assine_0_11880_PA_0_6_Retangulo'
  }
};

var defaultChannelData = {
  channel: {
    name: ''
  },
  schedule: [{
    shows: []
  }]
};
var tvScheduleEmptyDay = {
  currentChannel: {
    name: 'Esporte Interativo'
  },
  channels: (0, _keys2.default)(defaultChannels).map(function (channelName) {
    return (0, _extends3.default)({}, defaultChannelData, { channel: { name: channelName } });
  })
};

exports.default = tvScheduleEmptyDay;

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TvChannelSchedule = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.mapStateToProps = mapStateToProps;
exports.default = initTvSchedule;

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _date = __webpack_require__(181);

var _i18nProvider = __webpack_require__(18);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

var _preloadScores = __webpack_require__(410);

var _preloadScores2 = _interopRequireDefault(_preloadScores);

var _noUpcomingMatches = __webpack_require__(176);

var _noUpcomingMatches2 = _interopRequireDefault(_noUpcomingMatches);

var _scheduleNavigationScores = __webpack_require__(411);

var _scheduleNavigationScores2 = _interopRequireDefault(_scheduleNavigationScores);

var _tvChannelSelectionContainer = __webpack_require__(415);

var _tvScheduleActions = __webpack_require__(310);

var _tvChannelSelectionReducer = __webpack_require__(416);

var _tvChannelSelectionReducer2 = _interopRequireDefault(_tvChannelSelectionReducer);

var _appStore = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var TV_CHANNEL_SCHEDULE_COMPONENT_NAME = 'TvChannelsScheduleContainer';

function mapStateToProps(state) {
  var _state$TV_SCHEDULE_CO = state[_tvChannelSelectionContainer.TV_SCHEDULE_COMPONENT_STATE_KEY],
      IS_INITIALIZED = _state$TV_SCHEDULE_CO.IS_INITIALIZED,
      IS_LOADING = _state$TV_SCHEDULE_CO.IS_LOADING,
      channels = _state$TV_SCHEDULE_CO.channels,
      channelNames = _state$TV_SCHEDULE_CO.channelNames,
      currentChannelName = _state$TV_SCHEDULE_CO.currentChannelName,
      scheduleDate = _state$TV_SCHEDULE_CO.scheduleDate,
      minDate = _state$TV_SCHEDULE_CO.minDate,
      maxDate = _state$TV_SCHEDULE_CO.maxDate;

  return {
    dispatch: _appStore.dispatch,
    channels: channels,
    channelNames: channelNames,
    currentChannelName: currentChannelName,
    IS_INITIALIZED: IS_INITIALIZED,
    IS_LOADING: IS_LOADING,
    scheduleDate: scheduleDate,
    minDate: minDate,
    maxDate: maxDate
  };
}

function TvChannelShow(_ref) {
  var blockName = _ref.blockName,
      dateString = _ref.date,
      startTime = _ref.startTime,
      title = _ref.title,
      overview = _ref.overview,
      description = _ref.description;

  var tvChannelScheduledShowProps = {
    title: title,
    overview: overview,
    startTime: startTime,
    key: startTime,
    className: blockName + '__show'
  };
  var timeProps = {
    dateTime: startTime,
    className: blockName + '__start-time',
    children: (0, _date.toHourMinuteFromParts)({ dateString: dateString, timeString: startTime })
  };
  return _react2.default.createElement(
    'li',
    tvChannelScheduledShowProps,
    _react2.default.createElement('time', timeProps),
    _react2.default.createElement(
      'div',
      { className: blockName + '__details' },
      _react2.default.createElement(
        'h6',
        { className: blockName + '__title' },
        title
      ),
      _react2.default.createElement(
        'div',
        { className: blockName + '__overview' },
        overview
      )
    )
  );
}

function TvChannelDayShows(_ref2) {
  var blockName = _ref2.blockName,
      shows = _ref2.shows,
      date = _ref2.date;

  var dayShowsBaseProps = { blockName: 'tv-channel-day-shows' };
  var tvChannelDayShowsProps = (0, _extends3.default)({}, dayShowsBaseProps, {
    className: blockName + '__day-shows ' + dayShowsBaseProps.blockName,
    children: shows.map(function (show) {
      return TvChannelShow((0, _extends3.default)({}, show, dayShowsBaseProps, { date: date }));
    })
  });
  return _react2.default.createElement('ul', tvChannelDayShowsProps);
}

function TvScheduleShowsMaybeEmpty(_ref3) {
  var blockName = _ref3.blockName,
      shows = _ref3.shows,
      date = _ref3.date;

  return shows && shows.length ? _react2.default.createElement(TvChannelDayShows, { blockName: blockName, shows: shows, date: date }) : _react2.default.createElement(_noUpcomingMatches2.default, { message: (0, _i18nProvider.t)('homepage.no_matches') });
}

function TvScheduleFooterMaybeEmpty(_ref4) {
  var blockName = _ref4.blockName,
      shows = _ref4.shows;

  var tvScheduleFooterProps = {
    className: blockName + '__footer',
    children: (0, _i18nProvider.t)('pages.tv_programming.disclaimer')
  };
  return shows && shows.length ? _react2.default.createElement('footer', tvScheduleFooterProps) : _react2.default.createElement('noscript', null);
}

var tvChannelScheduleBlockName = 'tv-schedule';

var TvChannelSchedule = exports.TvChannelSchedule = function (_Component) {
  (0, _inherits3.default)(TvChannelSchedule, _Component);

  function TvChannelSchedule(props) {
    (0, _classCallCheck3.default)(this, TvChannelSchedule);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TvChannelSchedule.__proto__ || (0, _getPrototypeOf2.default)(TvChannelSchedule)).call(this, props));

    var onMoveToNextDay = _this.onMoveToNextDay,
        onMoveToPrevDay = _this.onMoveToPrevDay;

    (0, _assign2.default)(_this, {
      onMoveToNextDayBound: onMoveToNextDay.bind(_this),
      onMoveToPrevDayBound: onMoveToPrevDay.bind(_this)
    });
    return _this;
  }

  (0, _createClass3.default)(TvChannelSchedule, [{
    key: 'doesDayDataExists',
    value: function doesDayDataExists(scheduleDate) {
      var channels = this.props.channels;


      var scheduleData = channels.find(function (_ref5) {
        var schedule = _ref5.schedule;
        return schedule && schedule.length > 0;
      });

      return scheduleData && scheduleData.schedule.some(function (_ref6) {
        var date = _ref6.date;
        return (0, _date.isSameCalendarDay)((0, _date.getDateByIso8601string)(date), scheduleDate);
      });
    }
  }, {
    key: 'onMoveToNextDay',
    value: function onMoveToNextDay(e) {
      var _props = this.props,
          scheduleDate = _props.scheduleDate,
          maxDate = _props.maxDate;

      var nextDay = new Date(scheduleDate.getTime() + _date.DAY_IN_MILLISECONDS);
      if (nextDay <= maxDate) {
        this.changeDayData(nextDay);
      }
    }
  }, {
    key: 'onMoveToPrevDay',
    value: function onMoveToPrevDay(e) {
      var _props2 = this.props,
          scheduleDate = _props2.scheduleDate,
          minDate = _props2.minDate;

      var prevDay = new Date(scheduleDate.getTime() - _date.DAY_IN_MILLISECONDS);
      if (prevDay >= minDate) {
        this.changeDayData(prevDay);
      }
    }
  }, {
    key: 'changeDayData',
    value: function changeDayData(newDate) {
      var dispatch = this.props.dispatch;

      var dayDataExists = this.doesDayDataExists(newDate);
      !dayDataExists && dispatch((0, _tvScheduleActions.setLoading)());
      dispatch((0, _tvScheduleActions.changeTvScheduleDate)(newDate));
      !dayDataExists && dispatch((0, _tvScheduleActions.fetchData)(_tvChannelSelectionReducer.transformTvChannelsData, (0, _date.getCurrentIsoStringDate)(newDate)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          IS_INITIALIZED = _props3.IS_INITIALIZED,
          IS_LOADING = _props3.IS_LOADING,
          channels = _props3.channels,
          scheduleDate = _props3.scheduleDate,
          currentChannelName = _props3.currentChannelName,
          minDate = _props3.minDate,
          maxDate = _props3.maxDate;

      if (!IS_INITIALIZED || IS_LOADING) {
        return _react2.default.createElement(_preloadScores2.default, null);
      }
      var blockName = tvChannelScheduleBlockName;
      var currentChannel = channels.find(function (_ref7) {
        var channel = _ref7.channel;
        return channel.name === currentChannelName;
      });
      var currentDaySchdule = currentChannel && currentChannel.schedule.find(function (_ref8) {
        var date = _ref8.date;
        return (0, _date.isSameCalendarDay)((0, _date.getDateByIso8601string)(date), scheduleDate);
      }) || {};
      (0, _assign2.default)(currentDaySchdule, { blockName: blockName });
      var scheduleDayPagerProps = {
        currentDay: scheduleDate,
        minDate: minDate,
        maxDate: maxDate,
        className: blockName + '__day-pager',
        onMoveToNextDay: this.onMoveToNextDayBound,
        onMoveToPrevDay: this.onMoveToPrevDayBound
      };
      return _react2.default.createElement(
        'div',
        { className: blockName + '__container' },
        _react2.default.createElement(_scheduleNavigationScores2.default, scheduleDayPagerProps),
        _react2.default.createElement(TvScheduleShowsMaybeEmpty, currentDaySchdule),
        _react2.default.createElement(TvScheduleFooterMaybeEmpty, currentDaySchdule)
      );
    }
  }]);
  return TvChannelSchedule;
}(_react.Component);

var TvChannelScheduleContainer = {
  name: TV_CHANNEL_SCHEDULE_COMPONENT_NAME,
  stateKey: _tvChannelSelectionContainer.TV_SCHEDULE_COMPONENT_STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _tvScheduleActions.tvScheduleActions)(TvChannelSchedule),
  reducer: _tvChannelSelectionReducer2.default
};

function mountTvSchedule() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.TV_SCHEDULE_CHANNEL, TvChannelScheduleContainer));
}

var TV_SCHEDULE_FEATURE_ID = 'TvSchedule';

function initTvSchedule() {
  var shouldMountTvSchedule = (0, _pageDataObject.isSupportedForDomain)(TV_SCHEDULE_FEATURE_ID);
  if (shouldMountTvSchedule) {
    mountTvSchedule();
  }
  return shouldMountTvSchedule;
}

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEART_BEAT_PERIOD = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _values = __webpack_require__(127);

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _baseStore = __webpack_require__(77);

var _baseStore2 = _interopRequireDefault(_baseStore);

var _adActions = __webpack_require__(50);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _console = __webpack_require__(11);

var _object = __webpack_require__(12);

var _routerActions = __webpack_require__(208);

var _browsiActions = __webpack_require__(207);

var _string = __webpack_require__(47);

var _userToolbarActions = __webpack_require__(76);

var _analyticsActions = __webpack_require__(31);

var _pageDataObject = __webpack_require__(5);

var _socialButtonsActions = __webpack_require__(140);

var _fresh8Actions = __webpack_require__(135);

var _fantasyActionTypes = __webpack_require__(108);

var _socialBarActionTypes = __webpack_require__(98);

var _facebookBotActionTypes = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAnalyticsStore = _window.queryString.debugAnalyticsStore; /* eslint semi:0 */

var ANALYTICS_ACTION_TYPES = [].concat((0, _toConsumableArray3.default)((0, _values2.default)(_analyticsActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_socialButtonsActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_adActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_userToolbarActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_browsiActions.BROWSI_ACTIONS)), [_fresh8Actions.actions.FRESH8_ACTION_TYPES.DISPLAY_POPUP, _routerActions.TYPES.ROUTE_CHANGED, _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.DISPLAY, _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.LOAD_MORE, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.GET_TOURNAMENTS_FEED, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.SELECT_TOURNAMENT, _facebookBotActionTypes.FACEBOOK_BOT_ACTION_TYPES.GO_TO_MESSENGER_BOT]);

var HEART_BEAT_PERIOD = 30e3; // half a minute
var HEART_BEAT_BLACK_LIST_BY_DOMAIN = ['12up'];

function isHeartBeatNotBlackListedForCurrentDomain() {
  return !HEART_BEAT_BLACK_LIST_BY_DOMAIN.includes(_ua.domainFromFqdn);
}

var AnalyticsStore = function (_BaseStore) {
  (0, _inherits3.default)(AnalyticsStore, _BaseStore);

  function AnalyticsStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AnalyticsStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsStore.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsStore)).call(this, options));

    _this.reset();
    _this.listenToBrowserEvents();
    return _this;
  }

  (0, _createClass3.default)(AnalyticsStore, [{
    key: 'listenToBrowserEvents',
    value: function listenToBrowserEvents() {
      window.addEventListener('DOMContentLoaded', _analyticsActions.pageViewed);
    }
  }, {
    key: 'routeAction',
    value: function routeAction(action) {
      if (debugAnalyticsStore) {
        (0, _console.info)('STORE EMIT ACTION: ', action);
      }
      action.analyticsActionName = (0, _string.toCamelCase)(action.type.replace(/:/g, '_'));
      if (this.isAnalyticsAction(action.type)) {
        this.analyticsEvents.push(action); //Note: maybe this is not really needed... probably will be used just for debugging purpose
        this.recordActionInState(action);
        this.emitChange(action);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      var analyticsEvents = this.state.analyticsEvents || [];
      this.state = (0, _object.makeEmptyObj)();
      this.state.analyticsEvents = analyticsEvents;
      this.generatePageviewUid();
      if ((0, _pageDataObject.getIsPostPage)() && isHeartBeatNotBlackListedForCurrentDomain()) {
        if (this.heartbeatIntervalId) {
          clearInterval(this.heartbeatIntervalId);
        }
        this.heartbeatIntervalId = setInterval(_analyticsActions.heartBeat, HEART_BEAT_PERIOD);
      }
    }
  }, {
    key: 'generatePageviewUid',
    value: function generatePageviewUid() {
      this.state.pageviewUid = (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + Date.now();
      return this.state.pageviewUid;
    }
  }, {
    key: 'isAnalyticsAction',
    value: function isAnalyticsAction(actionType) {
      return ANALYTICS_ACTION_TYPES.includes(actionType);
    }
  }, {
    key: 'emitChange',
    value: function emitChange(action) {
      this.emit(this.constructor.EVENTS.CHANGE, action);
      return this;
    }
  }, {
    key: 'recordActionInState',
    value: function recordActionInState(action) {
      var actionType = (0, _string.toCamelCase)(action.type.split(':').pop());
      this.state[actionType] = (this.state[actionType] || 0) + 1;
    }
  }, {
    key: 'analyticsEvents',
    get: function get() {
      return this.state.analyticsEvents;
    }
  }, {
    key: 'heartbeatsCount',
    get: function get() {
      return this.state.heartBeat || 0;
    }
  }, {
    key: 'pageviewUid',
    get: function get() {
      return this.state.pageviewUid;
    }
  }]);
  return AnalyticsStore;
}(_baseStore2.default);

exports.default = AnalyticsStore;
exports.HEART_BEAT_PERIOD = HEART_BEAT_PERIOD;

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(227);

__webpack_require__(138);

__webpack_require__(195);

var _headerComponents = __webpack_require__(196);

var _headerComponents2 = _interopRequireDefault(_headerComponents);

var _localeCookieInitializer = __webpack_require__(146);

var _localeCookieInitializer2 = _interopRequireDefault(_localeCookieInitializer);

var _scoresTableContainer = __webpack_require__(689);

var _scoresTableContainer2 = _interopRequireDefault(_scoresTableContainer);

var _adblockDetectorProvider = __webpack_require__(154);

var _adblockDetectorProvider2 = _interopRequireDefault(_adblockDetectorProvider);

var _scheduleScoresContainer = __webpack_require__(686);

var _scheduleScoresContainer2 = _interopRequireDefault(_scheduleScoresContainer);

var _analyticsInitializer = __webpack_require__(142);

var _analyticsInitializer2 = _interopRequireDefault(_analyticsInitializer);

var _leagueSelectionScoresContainer = __webpack_require__(685);

var _leagueSelectionScoresContainer2 = _interopRequireDefault(_leagueSelectionScoresContainer);

var _videoAdTag = __webpack_require__(218);

var _tv_channel_selection = __webpack_require__(415);

var _tv_channel_selection2 = _interopRequireDefault(_tv_channel_selection);

var _tv_schedule_container = __webpack_require__(418);

var _tv_schedule_container2 = _interopRequireDefault(_tv_schedule_container);

var _trackAnalyticsClickEvents = __webpack_require__(137);

var _trackAnalyticsClickEvents2 = _interopRequireDefault(_trackAnalyticsClickEvents);

var _linksGroup = __webpack_require__(224);

var _hypernovaReact = __webpack_require__(191);

var _common = __webpack_require__(203);

var _montiContainer = __webpack_require__(291);

var _montiContainer2 = _interopRequireDefault(_montiContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
(0, _analyticsInitializer2.default)();
(0, _adblockDetectorProvider2.default)();
(0, _localeCookieInitializer2.default)();
(0, _headerComponents2.default)();
(0, _leagueSelectionScoresContainer2.default)();
(0, _scheduleScoresContainer2.default)();
(0, _scoresTableContainer2.default)();
(0, _trackAnalyticsClickEvents2.default)();
(0, _tv_channel_selection2.default)();
(0, _tv_schedule_container2.default)();
(0, _common.initCommonComponents)();
(0, _montiContainer2.default)();
(0, _videoAdTag.getVideoAdsTag)();
(0, _hypernovaReact.renderReact)('LinksGroupContainer', _linksGroup.LinksGroupContainer);

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptyMatchScores;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _emptyTeamScores = __webpack_require__(682);

var _emptyTeamScores2 = _interopRequireDefault(_emptyTeamScores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmptyMatchScores(_ref) {
  var blockName = _ref.blockName;

  var listItemBlockName = blockName + ' ' + blockName + '__list-item';
  return _react2.default.createElement(
    'li',
    { className: listItemBlockName },
    _react2.default.createElement(_emptyTeamScores2.default, { isHome: true, blockName: blockName }),
    _react2.default.createElement(_emptyTeamScores2.default, { isHome: false, blockName: blockName })
  );
}

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptyTeamScores;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmptyTeamScores(_ref) {
  var blockName = _ref.blockName,
      isHome = _ref.isHome;

  var homeOrAwayClass = isHome ? 'home' : 'away';
  var baseBlockName = blockName + '__list-item';
  var teamBlockName = baseBlockName + ' ' + baseBlockName + '--' + homeOrAwayClass;
  var shirtBlockName = blockName + '__shirt-placeholder';
  var teamNameBlockName = blockName + '__team-placeholder';
  return _react2.default.createElement(
    'div',
    { className: teamBlockName },
    _react2.default.createElement('div', { className: shirtBlockName }),
    _react2.default.createElement('div', { className: teamNameBlockName })
  );
}

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchDate;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'match-date-component';
function MatchDate(_ref) {
  var date = _ref.date;

  var time = _i18nProvider.i18n.l("time.formats.hour_minute", date);
  return _react2.default.createElement(
    'div',
    { className: blockName },
    time
  );
}

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchItemScores;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _matchWithResult = __webpack_require__(200);

var _matchWithResult2 = _interopRequireDefault(_matchWithResult);

var _team = __webpack_require__(201);

var _team2 = _interopRequireDefault(_team);

var _matchTransformUtil = __webpack_require__(122);

var _matchDateScores = __webpack_require__(683);

var _matchDateScores2 = _interopRequireDefault(_matchDateScores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPCOMING_MATCH = _matchTransformUtil.MATCH_STATUSES.UPCOMING; /* eslint semi:0 */

var blockName = 'match-container-component';

function MatchItemScores(_ref) {
  var homeTeam = _ref.homeTeam,
      awayTeam = _ref.awayTeam,
      result = _ref.result,
      date = _ref.date,
      matchStatus = _ref.status;

  var isStarted = matchStatus !== UPCOMING_MATCH;
  return _react2.default.createElement(
    'div',
    { className: blockName },
    _react2.default.createElement(
      'div',
      { className: blockName + '__teams-container' },
      _react2.default.createElement(_team2.default, {
        name: homeTeam.name,
        image: homeTeam.image,
        isHome: true
      }),
      isStarted ? _react2.default.createElement(_matchWithResult2.default, { result: result }) : _react2.default.createElement(_matchDateScores2.default, { date: date }),
      _react2.default.createElement(_team2.default, {
        name: awayTeam.name,
        image: awayTeam.image,
        isHome: false
      })
    )
  );
}

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixturesLeagueSelection = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = mountFixturesLeagueSelection;

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _scheduleReducer = __webpack_require__(177);

var _leagueSelection = __webpack_require__(199);

var _leagueSelection2 = _interopRequireDefault(_leagueSelection);

var _scheduleActions = __webpack_require__(109);

var _scheduleScoresTransformUtil = __webpack_require__(687);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var STATE_KEY = 'scheduleComponent';
var COMPONENT_NAME = 'FixturesLeagueSelectionContainer';
var LEAGUE_SELECTION_SCORES_MODIFIER = 'scores';

function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      leaguesForFixtures = _state$STATE_KEY.leaguesForFixtures,
      leagueName = _state$STATE_KEY.leagueName;

  return {
    leaguesForFixtures: leaguesForFixtures,
    leagueName: leagueName
  };
}

var FixturesLeagueSelection = exports.FixturesLeagueSelection = function (_Component) {
  (0, _inherits3.default)(FixturesLeagueSelection, _Component);

  function FixturesLeagueSelection() {
    (0, _classCallCheck3.default)(this, FixturesLeagueSelection);
    return (0, _possibleConstructorReturn3.default)(this, (FixturesLeagueSelection.__proto__ || (0, _getPrototypeOf2.default)(FixturesLeagueSelection)).apply(this, arguments));
  }

  (0, _createClass3.default)(FixturesLeagueSelection, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          IS_INITIALIZED = _props.IS_INITIALIZED,
          dispatch = _props.dispatch;

      if (!IS_INITIALIZED) {
        dispatch((0, _scheduleActions.fetchData)(_scheduleScoresTransformUtil.transformMatchResponseToFixturesSchedule));
      }
    }
  }, {
    key: 'onLeagueChanged',
    value: function onLeagueChanged(e) {
      var selectedLeague = e.target.value;

      this.props.dispatch((0, _scheduleActions.changeLeague)(selectedLeague));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          leagueName = _props2.leagueName,
          leaguesForFixtures = _props2.leaguesForFixtures;

      var leagueNamesForSelection = leaguesForFixtures.map(function (l) {
        return l.name;
      });
      var leagueSelectionProps = {
        currentLeague: leagueName,
        leagues: leagueNamesForSelection,
        modifier: LEAGUE_SELECTION_SCORES_MODIFIER,
        onChangeLeagueHandler: this.onLeagueChanged.bind(this)
      };
      return _react2.default.createElement(_leagueSelection2.default, leagueSelectionProps);
    }
  }]);
  return FixturesLeagueSelection;
}(_react.Component);

var FixturesLeagueSelectionContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps)(FixturesLeagueSelection),
  reducer: _scheduleReducer.scheduleReducer
};

function mountFixturesLeagueSelection() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE, FixturesLeagueSelectionContainer));
}

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixturesSchedule = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = mountFixturesSchedule;

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _date = __webpack_require__(181);

var _preloadScores = __webpack_require__(410);

var _preloadScores2 = _interopRequireDefault(_preloadScores);

var _i18nProvider = __webpack_require__(18);

var _matchItemScores = __webpack_require__(684);

var _matchItemScores2 = _interopRequireDefault(_matchItemScores);

var _noUpcomingMatches = __webpack_require__(176);

var _noUpcomingMatches2 = _interopRequireDefault(_noUpcomingMatches);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _scheduleReducer = __webpack_require__(177);

var _scheduleActions = __webpack_require__(109);

var _scheduleNavigationScores = __webpack_require__(411);

var _scheduleNavigationScores2 = _interopRequireDefault(_scheduleNavigationScores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATE_KEY = "scheduleComponent"; /* eslint semi:0 */

var COMPONENT_NAME = "FixturesScheduleContainer";

function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      IS_INITIALIZED = _state$STATE_KEY.IS_INITIALIZED,
      matches = _state$STATE_KEY.matches,
      leagueName = _state$STATE_KEY.leagueName,
      scheduleDate = _state$STATE_KEY.scheduleDate,
      leagueChanged = _state$STATE_KEY.leagueChanged;

  return {
    matches: matches,
    leagueName: leagueName,
    IS_INITIALIZED: IS_INITIALIZED,
    scheduleDate: scheduleDate,
    leagueChanged: leagueChanged
  };
}

function getMatchItemScores(match, i) {
  return _react2.default.createElement(_matchItemScores2.default, (0, _extends3.default)({ key: i }, match));
}

function getMatchesToDisplay(matches) {
  return matches.length ? matches.map(getMatchItemScores) : _react2.default.createElement(_noUpcomingMatches2.default, { message: (0, _i18nProvider.t)('homepage.no_matches') });
}

var FixturesSchedule = exports.FixturesSchedule = function (_Component) {
  (0, _inherits3.default)(FixturesSchedule, _Component);

  function FixturesSchedule(props) {
    (0, _classCallCheck3.default)(this, FixturesSchedule);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FixturesSchedule.__proto__ || (0, _getPrototypeOf2.default)(FixturesSchedule)).call(this, props));

    _this.onMoveToNextDayBound = _this.onMoveToNextDay.bind(_this);
    _this.onMoveToPrevDayBound = _this.onMoveToPrevDay.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FixturesSchedule, [{
    key: 'onMoveToNextDay',
    value: function onMoveToNextDay(e) {
      var _props = this.props,
          scheduleDate = _props.scheduleDate,
          changeScheduleDate = _props.changeScheduleDate;

      var nextDay = new Date(scheduleDate.getTime() + _date.DAY_IN_MILLISECONDS);
      changeScheduleDate(nextDay);
    }
  }, {
    key: 'onMoveToPrevDay',
    value: function onMoveToPrevDay(e) {
      var _props2 = this.props,
          scheduleDate = _props2.scheduleDate,
          changeScheduleDate = _props2.changeScheduleDate;

      var prevDay = new Date(scheduleDate.getTime() - _date.DAY_IN_MILLISECONDS);
      changeScheduleDate(prevDay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          IS_INITIALIZED = _props3.IS_INITIALIZED,
          matches = _props3.matches,
          scheduleDate = _props3.scheduleDate,
          leagueName = _props3.leagueName;

      if (!IS_INITIALIZED) {
        return _react2.default.createElement(_preloadScores2.default, null);
      }
      var blockName = 'fixtures-schedule';

      var _matches$matchesByLea = matches.matchesByLeague.find(function (leagueData) {
        return leagueData.leagueName === leagueName;
      }),
          leagueMatches = _matches$matchesByLea.leagueDayMatches;

      var minDate = leagueMatches && leagueMatches.length > 0 && leagueMatches[0].day;
      var maxDate = leagueMatches && leagueMatches.length > 0 && leagueMatches[leagueMatches.length - 1].day;
      var currentDayData = leagueMatches.find(function (dayEntry) {
        return (0, _date.isSameCalendarDay)(dayEntry.day, scheduleDate);
      });
      var currentDayMatches = currentDayData ? currentDayData.matches : [];
      var scheduleNavProps = {
        onMoveToNextDay: this.onMoveToNextDayBound,
        onMoveToPrevDay: this.onMoveToPrevDayBound,
        currentDay: scheduleDate,
        minDate: minDate,
        maxDate: maxDate
      };
      return _react2.default.createElement(
        'div',
        { className: blockName + '__container' },
        _react2.default.createElement(_scheduleNavigationScores2.default, scheduleNavProps),
        _react2.default.createElement(
          'div',
          { className: blockName + '__matches-list' },
          getMatchesToDisplay(currentDayMatches)
        )
      );
    }
  }]);
  return FixturesSchedule;
}(_react.Component);

var FixturesScheduleContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _scheduleActions.scheduleActions)(FixturesSchedule),
  reducer: _scheduleReducer.scheduleReducer
};

function mountFixturesSchedule() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.SCHEDULE_COMPONENT_IN_FIXTURES_PAGE, FixturesScheduleContainer));
}

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMatchResponseToFixturesSchedule = transformMatchResponseToFixturesSchedule;

var _matchTransformUtil = __webpack_require__(122);

var _date = __webpack_require__(181);

var _leagueTransformUtil = __webpack_require__(202);

var _array = __webpack_require__(101);

function flattenedMatches2data(flattened) {
  var date2Matches = {};
  var ret = [];

  var _loop = function _loop(i) {
    var match = flattened[i];
    var leagueId = match.leagueId,
        date = match.matchDate;

    var key = date.toDateString();
    if (!date2Matches[key]) {
      date2Matches[key] = {
        date: date,
        dayMatches: []
      };
      ret.push(date2Matches[key]);
    }
    var todaysLeaguesMatches = date2Matches[key];
    var leagueDayMatches = todaysLeaguesMatches.dayMatches.find(function (m) {
      return m.leagueId === leagueId;
    });
    if (!leagueDayMatches) {
      leagueDayMatches = { leagueId: leagueId, matches: [match.match] };
      todaysLeaguesMatches.dayMatches.push(leagueDayMatches);
    } else {
      leagueDayMatches.matches.push(match.match);
    }
  };

  for (var i = 0; i < flattened.length; i++) {
    _loop(i);
  }
  return ret;
}
function getLeagueDayMatches(matchesList, leagueId) {
  return (0, _array.flatten)(matchesList.map(function (dayMatches) {
    var date = dayMatches.date;

    var _ref = dayMatches.dayMatches.find(function (currentleagueDayMatches) {
      return currentleagueDayMatches.leagueId === leagueId;
    }) || { matches: [] },
        matches = _ref.matches;

    var matchesClean = matches.map(_matchTransformUtil.transformMatchResponse);
    return { day: date, matches: matchesClean };
  }));
}
function mapMatchesToMatchesWithDateAndNoTime(_ref2) {
  var match = _ref2.match,
      leagueId = _ref2.leagueId;
  var matchDateEpoch = match.start_time;

  var matchDate = (0, _date.getDateByTime)(new Date(matchDateEpoch * 1000));
  return { match: match, leagueId: leagueId, matchDate: matchDate };
}
function getCurrentLeagueDayMatches(leagueDayMatches) {
  var leagueId = leagueDayMatches.league_id;

  return leagueDayMatches.matches.map(function (match) {
    return mapMatchesToMatchesWithDateAndNoTime({ match: match, leagueId: leagueId });
  });
}
function getAllLeaguesDayMatches(dm) {
  var currLeagueDayMatchesList = dm.day_matches;

  return (0, _array.flatten)(currLeagueDayMatchesList.map(getCurrentLeagueDayMatches));
}
function getMatchesWithFixedDates(_ref3) {
  var matchesByDay = _ref3.matches;

  var ret = (0, _array.flatten)(matchesByDay.map(getAllLeaguesDayMatches));
  return ret;
}
function mapLeagueName2LeagueData(_ref4) {
  var leagueName = _ref4.leagueName,
      leagueId = _ref4.leagueId,
      dayMatchesList = _ref4.dayMatchesList;

  return {
    leagueName: leagueName,
    leagueId: leagueId,
    leagueDayMatches: getLeagueDayMatches(dayMatchesList, leagueId)
  };
}
function transformMatchResponseToFixturesSchedule(matchesData) {
  var dataWithFixedDates = getMatchesWithFixedDates(matchesData);
  var dayMatchesList = flattenedMatches2data(dataWithFixedDates);
  var leagueName2Id = (0, _leagueTransformUtil.getLeagueName2Id)();
  var leagueNames = (0, _leagueTransformUtil.getLeagueNames)();
  var leaguesData = leagueNames.map(function (leagueName) {
    return mapLeagueName2LeagueData({ leagueName: leagueName, leagueId: leagueName2Id[leagueName], dayMatchesList: dayMatchesList });
  });
  return {
    matches: {
      matchesByLeague: leaguesData,
      leagueNamesForSelection: leagueNames
    }
  };
}

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoresTable = ScoresTable;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'scores-table';
var TABLE_CELL_CLASS_NAME = blockName + '__cell';
var ROW_CLASS_NAME = blockName + '__row';
var ROW_PROMOTED_CLASS_NAMES = ROW_CLASS_NAME + ' ' + ROW_CLASS_NAME + '--promoted';
var TABLE_COLUMN_HEADINGS = ['Pos', 'Team', 'P', 'GD', 'Pts'];

/* eslint-disable camelcase */
function getPartitionClassName(index, _ref, tableLength) {
  var tableBottom = _ref.table_bottom,
      tableTop = _ref.table_top;

  var promotedIndexes = [tableBottom && tableLength - tableBottom, tableTop];
  return promotedIndexes.includes(index + 1) ? ROW_PROMOTED_CLASS_NAMES : ROW_CLASS_NAME;
}

function getTableCell(_ref2, cellData, key) {
  var tagName = _ref2.tagName,
      className = _ref2.className;

  return _react2.default.createElement(tagName, { className: className, key: key }, cellData);
}

function getCellList(cellListData, cellConfig) {
  return cellListData.map(getTableCell.part(cellConfig));
}

function getTableRows(_ref3) {
  var teams = _ref3.teams,
      partition = _ref3.partition;

  return teams.map(function (row, index, teamsList) {
    var teamName = row.name,
        gamesPlayed = row.games_played,
        goalDiff = row.goal_diff,
        points = row.points;

    return _react2.default.createElement(
      'tr',
      { key: index, className: getPartitionClassName(index, partition, teamsList.length) },
      getCellList([index + 1, teamName, gamesPlayed, goalDiff, points], {
        tagName: 'td',
        className: TABLE_CELL_CLASS_NAME
      })
    );
  });
}

/* eslint-enable camelcase */

function ScoresTable(_ref4) {
  var table = _ref4.table;

  var TABLE_CELL_HEADER = TABLE_CELL_CLASS_NAME + ' ' + TABLE_CELL_CLASS_NAME + '--header';
  return _react2.default.createElement(
    'table',
    { className: blockName + '__table' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'th',
          { colSpan: '5', className: blockName + '__top-header' },
          _react2.default.createElement(
            'h2',
            { className: blockName + '__title' },
            (0, _i18nProvider.t)('common.table')
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        { className: blockName + '__header' },
        getCellList(TABLE_COLUMN_HEADINGS, {
          tagName: 'th',
          className: TABLE_CELL_HEADER
        })
      ),
      getTableRows(table)
    )
  );
}

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scoresTable = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = mountScoresTable;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _scoresTableReducer = __webpack_require__(690);

var _scoresTableActions = __webpack_require__(412);

var _fetchSaga = __webpack_require__(56);

var _scoresTable = __webpack_require__(688);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_NAME = "scoresTable";
var STATE_KEY = "scoresTable";

function shouldShowScoresTable(table) {
  return table && table.teams && table.teams.length;
}

var scoresTable = exports.scoresTable = function (_Component) {
  (0, _inherits3.default)(scoresTable, _Component);

  function scoresTable() {
    (0, _classCallCheck3.default)(this, scoresTable);
    return (0, _possibleConstructorReturn3.default)(this, (scoresTable.__proto__ || (0, _getPrototypeOf2.default)(scoresTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(scoresTable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          IS_INITIALIZED = _props.IS_INITIALIZED,
          IS_ENTRY_POINT_MISSING = _props.IS_ENTRY_POINT_MISSING,
          fetchScoresTables = _props.fetchScoresTables;

      if (IS_ENTRY_POINT_MISSING) {
        return (0, _fetchSaga.getNoEndpointsErrorMessage)(this);
      }
      if (IS_INITIALIZED) {
        return true;
      }
      fetchScoresTables();
    }
  }, {
    key: 'getTableView',
    value: function getTableView() {
      var _props2 = this.props,
          tables = _props2.tables,
          selectedLeague = _props2.selectedLeague,
          IS_INITIALIZED = _props2.IS_INITIALIZED;

      return IS_INITIALIZED && shouldShowScoresTable(tables[selectedLeague]) ? _react2.default.createElement(_scoresTable.ScoresTable, { table: tables[selectedLeague] }) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.getTableView();
    }
  }]);
  return scoresTable;
}(_react.Component);

function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      tables = _state$STATE_KEY.tables,
      IS_INITIALIZED = _state$STATE_KEY.IS_INITIALIZED,
      IS_ENTRY_POINT_MISSING = _state$STATE_KEY.IS_ENTRY_POINT_MISSING,
      fetchScoresTables = _state$STATE_KEY.fetchScoresTables;
  var selectedLeague = state.scheduleComponent.leagueId;

  return { tables: tables, IS_INITIALIZED: IS_INITIALIZED, IS_ENTRY_POINT_MISSING: IS_ENTRY_POINT_MISSING, selectedLeague: selectedLeague, fetchScoresTables: fetchScoresTables };
}

var scoresTableContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _scoresTableActions.scoresTableActions)(scoresTable),
  reducer: _scoresTableReducer.scoresTableReducer
};

function mountScoresTable() {
  (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.SCORES_TABLE, scoresTableContainer));
}

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.scoresTableReducer = scoresTableReducer;

var _scoresTableActions = __webpack_require__(412);

var _fetchSaga = __webpack_require__(56);

var _fn = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  IS_INITIALIZED: false
};

function setState(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

function setActiveTable(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

function scoresTableReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('SCORES_TABLE_FETCH_ACTION_TYPES', _fetchSaga.getNamespacedFetchActionTypes, _scoresTableActions.API_ENDPOINT_NAME),
      SCORES_TABLE_FETCH_ACTION_TYPES = _memoizeFirstCall.SCORES_TABLE_FETCH_ACTION_TYPES;

  if (SCORES_TABLE_FETCH_ACTION_TYPES) {
    switch (action.type) {
      case SCORES_TABLE_FETCH_ACTION_TYPES.FETCH.SUCCESS:
        return setActiveTable(state, action.state);
      case SCORES_TABLE_FETCH_ACTION_TYPES.FETCH.FAILED:
        return setState(state, action.state);
      default:
        return state;
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true });
}

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TvChannelSelection;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectOption(optionText, blockName) {
  var optionProps = {
    key: optionText,
    value: optionText,
    children: optionText,
    className: blockName + '__option'
  };
  return _react2.default.createElement('option', optionProps);
} /* eslint semi:0 */
function TvChannelSelection(_ref) {
  var blockName = _ref.blockName,
      modifier = _ref.modifier,
      entityName = _ref.entityName,
      _ref$available = _ref.available,
      available = _ref$available === undefined ? [] : _ref$available,
      value = _ref.selected,
      onChange = _ref.onChange,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === undefined ? false || available.length === 0 : _ref$isDisabled;

  var containerClassName = modifier ? blockName + ' ' + blockName + '--' + modifier : blockName;
  var selectProps = {
    value: value,
    onChange: onChange,
    disabled: isDisabled,
    children: available.map(function (optionText) {
      return SelectOption(optionText, blockName);
    }),
    className: blockName + '__select ' + blockName + '--' + entityName
  };
  return _react2.default.createElement(
    'div',
    { className: containerClassName },
    _react2.default.createElement(
      'div',
      { className: blockName + '__wrapper' },
      _react2.default.createElement('select', selectProps)
    )
  );
}

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTI_PREROLL_AD_TYPE_PREFIX = undefined;

var _map = __webpack_require__(225);

var _map2 = _interopRequireDefault(_map);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.getVideoAdTargeting = getVideoAdTargeting;
exports.getVideoAdServerUrl = getVideoAdServerUrl;
exports.getVideoTag = getVideoTag;
exports.default = setPageTargeting;

var _array = __webpack_require__(101);

var _object = __webpack_require__(12);

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _pageContext = __webpack_require__(61);

var _userStore = __webpack_require__(38);

var _ua = __webpack_require__(10);

var _i18nProvider = __webpack_require__(18);

var _adsConfig = __webpack_require__(27);

var _console = __webpack_require__(11);

var _geolocationProvider = __webpack_require__(44);

var _pageDataObject = __webpack_require__(5);

var _useridentifierTracker = __webpack_require__(136);

var _trafficAnalyzerService = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CUSTOM_CRITERIA_PREFIX = _adsConfig.ADS_QUERYSTRING_OVERRIDE_PREFIXES.CUSTOM_CRITERIA;
var DEBUG_CC = _window.queryString.adsDebugCc;

var getCcWithQsOverride = _window.getPossiblyOverriddenPropByQsWithPrefix.part(CUSTOM_CRITERIA_PREFIX);
var DEBUG_CC_SPORTS_TYPES = _window.queryString.adsDebugSportsTypes;
var SPORTS_TYPE_FOOTBALL = 'Soccer';
var SPORTS_TYPE_AMERICAN = 'American';
var SPORTS_TYPE_NEWS = 'News';
var SPORTS_TYPE_DEFAULT = SPORTS_TYPE_FOOTBALL;
var SPORTS_TYPE_BY_DOMAIN = {
  '12up': SPORTS_TYPE_AMERICAN,
  pluralist: SPORTS_TYPE_NEWS
};
var MONTI_PREROLL_AD_TYPE_PREFIX = exports.MONTI_PREROLL_AD_TYPE_PREFIX = 'preroll';
var MONTI_MIDROLL_AD_TYPE_PREFIX = 'midroll';
var MONTI_FIRST_PREROLLS_AD_TYPES = ['preroll0', 'preroll1'];

var affiliateId = (0, _pageContext.getInfluencerId)() || '0';

function dfpTargetingValueToString(value) {
  if ((0, _array.isArray)(value)) {
    return value;
  }
  return value.toString();
}

function debugGroup(groupName) {
  DEBUG_CC && (0, _console.groupCollapsed)('Custom Criteria: ' + groupName + ' ads');
}

function debugGroupEnd() {
  DEBUG_CC && (0, _console.groupEnd)();
}

function setTargetingViaTargetingFn(setTargetingFn, key, value) {
  DEBUG_CC && (0, _console.info)('%c[CC] %s:', 'font-style: italic; color: green;', key, value);
  (0, _fn.makeSafeFn)(setTargetingFn).invoke(key, value);
}

function setCustomCriteria(setTargetingFn, customCriteriaValue, customCriteriaName) {
  var possiblyOverridenCcValue = getCcWithQsOverride(customCriteriaName, customCriteriaValue);
  if (possiblyOverridenCcValue) {
    setTargetingViaTargetingFn(setTargetingFn, customCriteriaName, possiblyOverridenCcValue);
  }
  return setTargetingFn;
}

function addCustomCriteria(setTargetingFn, additionalCustomCriteriaKey) {
  return setCustomCriteria(setTargetingFn, undefined, additionalCustomCriteriaKey);
}

var removeCcPrefix = _window.unprefixQsProperty.part(CUSTOM_CRITERIA_PREFIX);

function isUnknownCustomCriteria(qsKey, index, allQsKeys) {
  // this function has to be bound to customCriteriaMap to work
  return qsKey.startsWith(CUSTOM_CRITERIA_PREFIX) && !(removeCcPrefix(qsKey) in this);
}

var DEFAULT_ENV = 'production';

function getAdditionalCustomCriteriaKeys(customCriteriaMap) {
  return (0, _keys2.default)(_window.queryString).filter(isUnknownCustomCriteria, customCriteriaMap).map(removeCcPrefix);
}

function getLocaleNameForDfp() {
  return (0, _i18nProvider.getShortLocale)().toUpperCase();
}

var countryCode = _geolocationProvider.NO_LOCATION;

function setCurrentCountryCode(countryCodeResult) {
  countryCode = countryCodeResult;
}

(0, _geolocationProvider.getCountryCode)().then(setCurrentCountryCode).catch(_fn.noop);

function getCustomCriteriaMapFromQueryString(qs) {
  /* eslint-disable camelcase */
  var utmMedium = qs.utm_medium,
      utmSource = qs.utm_source,
      utmCampaign = qs.utm_campaign,
      partnerId = qs.partnerId;
  // eslint-enable

  return {
    affiliateId: affiliateId,
    partnerId: partnerId,
    utmMedium: utmMedium,
    utmSource: utmSource,
    utmCampaign: utmCampaign
  };
}

function getSportsTypesByDomain(domain) {
  var singleSportsType = SPORTS_TYPE_BY_DOMAIN[domain] || SPORTS_TYPE_DEFAULT;
  DEBUG_CC_SPORTS_TYPES && (0, _console.info)('[CC]\ncurrent domain: %s,\nsports-type: %s', domain, singleSportsType);
  return [singleSportsType];
}

function getPromotedMediaCc() {
  return (0, _pageDataObject.get)('post.title', '').includes('VIDEO') ? 'video' : null;
}

function isSkinEligible() {
  return window.innerWidth > 321 ? true : false;
}

function getBaseCustomCriteriaMap() {
  var mainLevels = _pageDataObject.ads.hierarchyLevels.mainLevels;

  var baseCc = {
    // FIXME: not just football any longer!
    sportsTypes: getSportsTypesByDomain((0, _ua.domainFromFqdn)()),
    language: getLocaleNameForDfp(),
    platform: (0, _ua.getPlatform)(),
    articleId: (0, _pageDataObject.get)('post.id'),
    articleTemplate: (0, _pageDataObject.get)('post.template'),
    env: (0, _pageDataObject.get)('config.env', DEFAULT_ENV),
    categories: (0, _pageDataObject.get)('post.categories'),
    viewportOrientation: _ua.viewport.orientation,
    adUnitPath: mainLevels,
    countryCode: countryCode,
    markupFormat: 'web',
    promotedMedia: getPromotedMediaCc(),
    articleTeams: (0, _pageDataObject.get)('post.content_tags'),
    experimentId: undefined !== window.experimentId ? window.experimentId : '',
    format: _ua.path.isSyndication ? 'synd' : '',
    syndicationPartnerId: _ua.path.isSyndication ? (0, _pageContext.getSyndicationPartnerId)() : '',
    userIdentifier: (0, _useridentifierTracker.trackUserIdentifier)(),
    skinEligible: isSkinEligible()
    // TODOS:
    // contentProvider: 'ESPN'
    // sizes: requested slot sizes ['970x250', '300x600', ]
    // screenSize: viewport breakpoint
  };
  return (0, _extends3.default)({}, baseCc, getCustomCriteriaMapFromQueryString(_window.queryString), mainLevels);
}

var pageVideoCustomCriteria = new _map2.default();

function addVideoCcKeyValuePairToThis(ccValue, ccKey) {
  var isCcValueStringable = ccValue !== undefined && ccValue.toString instanceof Function;
  var value = isCcValueStringable ? ccValue.toString() : '';
  if (value.length) {
    this.push(ccKey + '=' + value);
  }
  return this;
}

function getVideoAdTargeting() {
  var instanceCustomCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _map2.default();

  if (pageVideoCustomCriteria.size === 0) {
    var setTargetingFn = pageVideoCustomCriteria.set.bind(pageVideoCustomCriteria);
    var setVideoCc = setCustomCriteria.bind(null, setTargetingFn);
    debugGroup('video');
    var baseCustomCriteriaMap = getBaseCustomCriteriaMap();
    var trafficInfo = (0, _trafficAnalyzerService.getTrafficInfo)();
    var customCriteriaMap = (0, _extends3.default)({}, baseCustomCriteriaMap, trafficInfo);
    (0, _object.iterate)(customCriteriaMap, setVideoCc);
    var additionalCustomCriteriaKeys = getAdditionalCustomCriteriaKeys(customCriteriaMap);
    var addVideoCc = addCustomCriteria.bind(null, setTargetingFn);
    additionalCustomCriteriaKeys.forEach(addVideoCc);
    debugGroupEnd();
  }
  var videoCustomCriteria = [];
  pageVideoCustomCriteria.forEach(addVideoCcKeyValuePairToThis, videoCustomCriteria);
  instanceCustomCriteria.forEach(addVideoCcKeyValuePairToThis, videoCustomCriteria);

  var videoCustomCriteriaMap = {};
  videoCustomCriteria.forEach(function (cust_param) {
    var arr = cust_param.split('=');
    videoCustomCriteriaMap[arr[0]] = arr[1];
  });
  return videoCustomCriteriaMap;
}

function adTypeParam(adType) {
  if (adType && adType.startsWith(MONTI_PREROLL_AD_TYPE_PREFIX)) {
    return 'mm_preroll=' + adType.substr(adType.indexOf(MONTI_PREROLL_AD_TYPE_PREFIX) + MONTI_PREROLL_AD_TYPE_PREFIX.length, adType.length);
  } else if (adType && adType.startsWith(MONTI_MIDROLL_AD_TYPE_PREFIX)) {
    return 'mm_midroll=' + adType.substr(adType.indexOf(MONTI_MIDROLL_AD_TYPE_PREFIX) + MONTI_MIDROLL_AD_TYPE_PREFIX.length, adType.length);
  } else {
    return '';
  }
}

function getConsent() {
  var consent = localStorage.getItem('consentData');
  var isGdpr = localStorage.getItem('gdprApplies') ? '1' : '0';
  return '&gdpr=' + isGdpr + '&gdpr_consent=' + consent;
}

function video_cust_param(adType) {
  var cust_param = getVideoAdTargeting();
  var str = '';
  for (var c in cust_param) {
    str += c + '=' + cust_param[c] + '&';
  }
  str += adTypeParam(adType) + '&';
  str += getConsent();
  return encodeURIComponent(str);
}

function getAdUnitPath() {
  var hierarchyLevels = _pageDataObject.ads.hierarchyLevels;

  hierarchyLevels.l4 = _adsConfig.AD_FORMATS.Video;
  return hierarchyLevels.toString();
}

function getVideoAdServerUrl(description_url, adType) {
  var referel = window.location.href;
  var parsedDescriptionUrl = description_url || referel;
  return 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360|480x270|400x300|640x480&iu=/' + getAdUnitPath() + '&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=' + referel + '&description_url=' + parsedDescriptionUrl + '&correlator=' + Date.now() + '&cust_params=' + video_cust_param(adType);
}

function getVideoTag(description_url, adType) {
  return getVideoAdServerUrl(description_url, adType);
}

function setPageTargeting(gTag) {
  var additionalCcMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var setTargetingFn = function getDfpSetTargeting(ccKey, ccValue) {
    ccValue = dfpTargetingValueToString(ccValue); // eslint-disable-line no-param-reassign
    if (DEBUG_CC === 'verbose') {
      (0, _console.info)('%c[CC] %s:', 'font-style: italic; color: blue;', 'ccKey: \'' + ccKey + '\', ccValue: \'' + ccValue + '\'');
    }
    return gTag.pubads().setTargeting(ccKey, ccValue);
  };

  var setGtagCc = setCustomCriteria.bind(null, setTargetingFn);
  var customCriteriaMap = (0, _extends3.default)({}, getBaseCustomCriteriaMap(), additionalCcMap);
  debugGroup('display');
  (0, _object.iterate)(customCriteriaMap, setGtagCc);
  var additionalCustomCriteriaKeys = getAdditionalCustomCriteriaKeys(customCriteriaMap);
  var addGtagCc = addCustomCriteria.bind(null, setTargetingFn);
  additionalCustomCriteriaKeys.forEach(addGtagCc);
  debugGroupEnd();
  return gTag;
}

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildrenWithProps = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.withParentAttributesAsProps = withParentAttributesAsProps;
exports.reactDataset = reactDataset;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _string = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cloneChildrenWithProps = exports.cloneChildrenWithProps = function cloneChildrenWithProps(children, props) {
  return _react2.default.Children.map(children, function (child) {
    return child ? _react2.default.cloneElement(child, props) : false;
  });
};

function withParentAttributesAsProps(Component) {
  return function (_Component) {
    (0, _inherits3.default)(WithParentAttributesAsProps, _Component);

    function WithParentAttributesAsProps() {
      (0, _classCallCheck3.default)(this, WithParentAttributesAsProps);
      return (0, _possibleConstructorReturn3.default)(this, (WithParentAttributesAsProps.__proto__ || (0, _getPrototypeOf2.default)(WithParentAttributesAsProps)).apply(this, arguments));
    }

    (0, _createClass3.default)(WithParentAttributesAsProps, [{
      key: 'componentWillMount',
      value: function componentWillMount() {}
    }, {
      key: 'render',
      value: function render() {
        var props = this.props,
            dataset = this.dataset;

        return _react2.default.createElement(Component, (0, _extends4.default)({}, props, dataset));
      }
    }]);
    return WithParentAttributesAsProps;
  }(Component);
}

function reactDataset(data) {
  return (0, _keys2.default)(data).reduce(function (acc, dataAttr) {
    return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, 'data-' + (0, _string.camelCaseToDashDelimited)(dataAttr), data[dataAttr]));
  }, {});
}

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.fetchReactions = fetchReactions;
exports.fetchPostMetadata = fetchPostMetadata;
exports.sendData = sendData;

var _actionCounterBaseProvider = __webpack_require__(153);

var _mithril = __webpack_require__(34);

var _fetch = __webpack_require__(57);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var POST_METADATA = 'Post_' + (0, _pageDataObject.getPostId)();
var REACTIONS = 'PostReactions_' + (0, _pageDataObject.getPostId)();

var ACTION_COUNTER_KEYS = [REACTIONS, POST_METADATA];

function canSendData() {
  var hostsUrls = (0, _actionCounterBaseProvider.getActionProviderHosts)();
  var reportingTargets = (0, _keys2.default)(hostsUrls).map(function (k) {
    return hostsUrls[k];
  });
  return !reportingTargets.includes(_actionCounterBaseProvider.NO_HOST);
}

function fetchCounterByKey(key) {
  return (0, _actionCounterBaseProvider.fetchCounters)(ACTION_COUNTER_KEYS).then(function (counters) {
    return counters[key];
  });
}

function fetchReactions() {
  return fetchCounterByKey(REACTIONS);
}

function fetchPostMetadata() {
  return fetchCounterByKey(POST_METADATA);
}

function sendData(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canSendData()) {
    return _promise2.default.reject('cannot report to action counter.');
  }

  params.ts = Date.now();

  var _getActionProviderHos = (0, _actionCounterBaseProvider.getActionProviderHosts)(),
      baseUrl = _getActionProviderHos.WRITER_ACTION_PROVIDER;

  var serializedParams = _mithril.route.buildQueryString(params);
  var url = '//' + baseUrl + '/' + type + '?' + serializedParams;
  return (0, _fetch.getResponseText)(url);
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_BAR_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var SOCIAL_BAR_ACTION_TYPES = exports.SOCIAL_BAR_ACTION_TYPES = (0, _object.namespacedConsts)({
  REACTIONS: {
    GET_VOTES: true,
    SEND_VOTE: true,
    DISPLAY: true,
    HIDE: true,
    SET_REACTIONS_COMPONENT_STATE: true
  }
});

/***/ })

},[1360]);


// WEBPACK FOOTER //
// webpack-scoresAndPages.js